// Generated from PrismarineJS/minecraft-data 3.111.0 (MIT) for Minecraft Java 1.21.11.
// Do not edit manually; refresh the catalog when the configured servers are upgraded.
export const MINECRAFT_ITEMS = [
    {
        id: 'minecraft:stone',
        name: 'Stone',
    },
    {
        id: 'minecraft:granite',
        name: 'Granite',
    },
    {
        id: 'minecraft:polished_granite',
        name: 'Polished Granite',
    },
    {
        id: 'minecraft:diorite',
        name: 'Diorite',
    },
    {
        id: 'minecraft:polished_diorite',
        name: 'Polished Diorite',
    },
    {
        id: 'minecraft:andesite',
        name: 'Andesite',
    },
    {
        id: 'minecraft:polished_andesite',
        name: 'Polished Andesite',
    },
    {
        id: 'minecraft:deepslate',
        name: 'Deepslate',
    },
    {
        id: 'minecraft:cobbled_deepslate',
        name: 'Cobbled Deepslate',
    },
    {
        id: 'minecraft:polished_deepslate',
        name: 'Polished Deepslate',
    },
    {
        id: 'minecraft:calcite',
        name: 'Calcite',
    },
    {
        id: 'minecraft:tuff',
        name: 'Tuff',
    },
    {
        id: 'minecraft:tuff_slab',
        name: 'Tuff Slab',
    },
    {
        id: 'minecraft:tuff_stairs',
        name: 'Tuff Stairs',
    },
    {
        id: 'minecraft:tuff_wall',
        name: 'Tuff Wall',
    },
    {
        id: 'minecraft:chiseled_tuff',
        name: 'Chiseled Tuff',
    },
    {
        id: 'minecraft:polished_tuff',
        name: 'Polished Tuff',
    },
    {
        id: 'minecraft:polished_tuff_slab',
        name: 'Polished Tuff Slab',
    },
    {
        id: 'minecraft:polished_tuff_stairs',
        name: 'Polished Tuff Stairs',
    },
    {
        id: 'minecraft:polished_tuff_wall',
        name: 'Polished Tuff Wall',
    },
    {
        id: 'minecraft:tuff_bricks',
        name: 'Tuff Bricks',
    },
    {
        id: 'minecraft:tuff_brick_slab',
        name: 'Tuff Brick Slab',
    },
    {
        id: 'minecraft:tuff_brick_stairs',
        name: 'Tuff Brick Stairs',
    },
    {
        id: 'minecraft:tuff_brick_wall',
        name: 'Tuff Brick Wall',
    },
    {
        id: 'minecraft:chiseled_tuff_bricks',
        name: 'Chiseled Tuff Bricks',
    },
    {
        id: 'minecraft:dripstone_block',
        name: 'Dripstone Block',
    },
    {
        id: 'minecraft:grass_block',
        name: 'Grass Block',
    },
    {
        id: 'minecraft:dirt',
        name: 'Dirt',
    },
    {
        id: 'minecraft:coarse_dirt',
        name: 'Coarse Dirt',
    },
    {
        id: 'minecraft:podzol',
        name: 'Podzol',
    },
    {
        id: 'minecraft:rooted_dirt',
        name: 'Rooted Dirt',
    },
    {
        id: 'minecraft:mud',
        name: 'Mud',
    },
    {
        id: 'minecraft:crimson_nylium',
        name: 'Crimson Nylium',
    },
    {
        id: 'minecraft:warped_nylium',
        name: 'Warped Nylium',
    },
    {
        id: 'minecraft:cobblestone',
        name: 'Cobblestone',
    },
    {
        id: 'minecraft:oak_planks',
        name: 'Oak Planks',
    },
    {
        id: 'minecraft:spruce_planks',
        name: 'Spruce Planks',
    },
    {
        id: 'minecraft:birch_planks',
        name: 'Birch Planks',
    },
    {
        id: 'minecraft:jungle_planks',
        name: 'Jungle Planks',
    },
    {
        id: 'minecraft:acacia_planks',
        name: 'Acacia Planks',
    },
    {
        id: 'minecraft:cherry_planks',
        name: 'Cherry Planks',
    },
    {
        id: 'minecraft:dark_oak_planks',
        name: 'Dark Oak Planks',
    },
    {
        id: 'minecraft:pale_oak_planks',
        name: 'Pale Oak Planks',
    },
    {
        id: 'minecraft:mangrove_planks',
        name: 'Mangrove Planks',
    },
    {
        id: 'minecraft:bamboo_planks',
        name: 'Bamboo Planks',
    },
    {
        id: 'minecraft:crimson_planks',
        name: 'Crimson Planks',
    },
    {
        id: 'minecraft:warped_planks',
        name: 'Warped Planks',
    },
    {
        id: 'minecraft:bamboo_mosaic',
        name: 'Bamboo Mosaic',
    },
    {
        id: 'minecraft:oak_sapling',
        name: 'Oak Sapling',
    },
    {
        id: 'minecraft:spruce_sapling',
        name: 'Spruce Sapling',
    },
    {
        id: 'minecraft:birch_sapling',
        name: 'Birch Sapling',
    },
    {
        id: 'minecraft:jungle_sapling',
        name: 'Jungle Sapling',
    },
    {
        id: 'minecraft:acacia_sapling',
        name: 'Acacia Sapling',
    },
    {
        id: 'minecraft:cherry_sapling',
        name: 'Cherry Sapling',
    },
    {
        id: 'minecraft:dark_oak_sapling',
        name: 'Dark Oak Sapling',
    },
    {
        id: 'minecraft:pale_oak_sapling',
        name: 'Pale Oak Sapling',
    },
    {
        id: 'minecraft:mangrove_propagule',
        name: 'Mangrove Propagule',
    },
    {
        id: 'minecraft:bedrock',
        name: 'Bedrock',
    },
    {
        id: 'minecraft:sand',
        name: 'Sand',
    },
    {
        id: 'minecraft:suspicious_sand',
        name: 'Suspicious Sand',
    },
    {
        id: 'minecraft:suspicious_gravel',
        name: 'Suspicious Gravel',
    },
    {
        id: 'minecraft:red_sand',
        name: 'Red Sand',
    },
    {
        id: 'minecraft:gravel',
        name: 'Gravel',
    },
    {
        id: 'minecraft:coal_ore',
        name: 'Coal Ore',
    },
    {
        id: 'minecraft:deepslate_coal_ore',
        name: 'Deepslate Coal Ore',
    },
    {
        id: 'minecraft:iron_ore',
        name: 'Iron Ore',
    },
    {
        id: 'minecraft:deepslate_iron_ore',
        name: 'Deepslate Iron Ore',
    },
    {
        id: 'minecraft:copper_ore',
        name: 'Copper Ore',
    },
    {
        id: 'minecraft:deepslate_copper_ore',
        name: 'Deepslate Copper Ore',
    },
    {
        id: 'minecraft:gold_ore',
        name: 'Gold Ore',
    },
    {
        id: 'minecraft:deepslate_gold_ore',
        name: 'Deepslate Gold Ore',
    },
    {
        id: 'minecraft:redstone_ore',
        name: 'Redstone Ore',
    },
    {
        id: 'minecraft:deepslate_redstone_ore',
        name: 'Deepslate Redstone Ore',
    },
    {
        id: 'minecraft:emerald_ore',
        name: 'Emerald Ore',
    },
    {
        id: 'minecraft:deepslate_emerald_ore',
        name: 'Deepslate Emerald Ore',
    },
    {
        id: 'minecraft:lapis_ore',
        name: 'Lapis Lazuli Ore',
    },
    {
        id: 'minecraft:deepslate_lapis_ore',
        name: 'Deepslate Lapis Lazuli Ore',
    },
    {
        id: 'minecraft:diamond_ore',
        name: 'Diamond Ore',
    },
    {
        id: 'minecraft:deepslate_diamond_ore',
        name: 'Deepslate Diamond Ore',
    },
    {
        id: 'minecraft:nether_gold_ore',
        name: 'Nether Gold Ore',
    },
    {
        id: 'minecraft:nether_quartz_ore',
        name: 'Nether Quartz Ore',
    },
    {
        id: 'minecraft:ancient_debris',
        name: 'Ancient Debris',
    },
    {
        id: 'minecraft:coal_block',
        name: 'Block of Coal',
    },
    {
        id: 'minecraft:raw_iron_block',
        name: 'Block of Raw Iron',
    },
    {
        id: 'minecraft:raw_copper_block',
        name: 'Block of Raw Copper',
    },
    {
        id: 'minecraft:raw_gold_block',
        name: 'Block of Raw Gold',
    },
    {
        id: 'minecraft:heavy_core',
        name: 'Heavy Core',
    },
    {
        id: 'minecraft:amethyst_block',
        name: 'Block of Amethyst',
    },
    {
        id: 'minecraft:budding_amethyst',
        name: 'Budding Amethyst',
    },
    {
        id: 'minecraft:iron_block',
        name: 'Block of Iron',
    },
    {
        id: 'minecraft:copper_block',
        name: 'Block of Copper',
    },
    {
        id: 'minecraft:gold_block',
        name: 'Block of Gold',
    },
    {
        id: 'minecraft:diamond_block',
        name: 'Block of Diamond',
    },
    {
        id: 'minecraft:netherite_block',
        name: 'Block of Netherite',
    },
    {
        id: 'minecraft:exposed_copper',
        name: 'Exposed Copper',
    },
    {
        id: 'minecraft:weathered_copper',
        name: 'Weathered Copper',
    },
    {
        id: 'minecraft:oxidized_copper',
        name: 'Oxidized Copper',
    },
    {
        id: 'minecraft:chiseled_copper',
        name: 'Chiseled Copper',
    },
    {
        id: 'minecraft:exposed_chiseled_copper',
        name: 'Exposed Chiseled Copper',
    },
    {
        id: 'minecraft:weathered_chiseled_copper',
        name: 'Weathered Chiseled Copper',
    },
    {
        id: 'minecraft:oxidized_chiseled_copper',
        name: 'Oxidized Chiseled Copper',
    },
    {
        id: 'minecraft:cut_copper',
        name: 'Cut Copper',
    },
    {
        id: 'minecraft:exposed_cut_copper',
        name: 'Exposed Cut Copper',
    },
    {
        id: 'minecraft:weathered_cut_copper',
        name: 'Weathered Cut Copper',
    },
    {
        id: 'minecraft:oxidized_cut_copper',
        name: 'Oxidized Cut Copper',
    },
    {
        id: 'minecraft:cut_copper_stairs',
        name: 'Cut Copper Stairs',
    },
    {
        id: 'minecraft:exposed_cut_copper_stairs',
        name: 'Exposed Cut Copper Stairs',
    },
    {
        id: 'minecraft:weathered_cut_copper_stairs',
        name: 'Weathered Cut Copper Stairs',
    },
    {
        id: 'minecraft:oxidized_cut_copper_stairs',
        name: 'Oxidized Cut Copper Stairs',
    },
    {
        id: 'minecraft:cut_copper_slab',
        name: 'Cut Copper Slab',
    },
    {
        id: 'minecraft:exposed_cut_copper_slab',
        name: 'Exposed Cut Copper Slab',
    },
    {
        id: 'minecraft:weathered_cut_copper_slab',
        name: 'Weathered Cut Copper Slab',
    },
    {
        id: 'minecraft:oxidized_cut_copper_slab',
        name: 'Oxidized Cut Copper Slab',
    },
    {
        id: 'minecraft:waxed_copper_block',
        name: 'Waxed Block of Copper',
    },
    {
        id: 'minecraft:waxed_exposed_copper',
        name: 'Waxed Exposed Copper',
    },
    {
        id: 'minecraft:waxed_weathered_copper',
        name: 'Waxed Weathered Copper',
    },
    {
        id: 'minecraft:waxed_oxidized_copper',
        name: 'Waxed Oxidized Copper',
    },
    {
        id: 'minecraft:waxed_chiseled_copper',
        name: 'Waxed Chiseled Copper',
    },
    {
        id: 'minecraft:waxed_exposed_chiseled_copper',
        name: 'Waxed Exposed Chiseled Copper',
    },
    {
        id: 'minecraft:waxed_weathered_chiseled_copper',
        name: 'Waxed Weathered Chiseled Copper',
    },
    {
        id: 'minecraft:waxed_oxidized_chiseled_copper',
        name: 'Waxed Oxidized Chiseled Copper',
    },
    {
        id: 'minecraft:waxed_cut_copper',
        name: 'Waxed Cut Copper',
    },
    {
        id: 'minecraft:waxed_exposed_cut_copper',
        name: 'Waxed Exposed Cut Copper',
    },
    {
        id: 'minecraft:waxed_weathered_cut_copper',
        name: 'Waxed Weathered Cut Copper',
    },
    {
        id: 'minecraft:waxed_oxidized_cut_copper',
        name: 'Waxed Oxidized Cut Copper',
    },
    {
        id: 'minecraft:waxed_cut_copper_stairs',
        name: 'Waxed Cut Copper Stairs',
    },
    {
        id: 'minecraft:waxed_exposed_cut_copper_stairs',
        name: 'Waxed Exposed Cut Copper Stairs',
    },
    {
        id: 'minecraft:waxed_weathered_cut_copper_stairs',
        name: 'Waxed Weathered Cut Copper Stairs',
    },
    {
        id: 'minecraft:waxed_oxidized_cut_copper_stairs',
        name: 'Waxed Oxidized Cut Copper Stairs',
    },
    {
        id: 'minecraft:waxed_cut_copper_slab',
        name: 'Waxed Cut Copper Slab',
    },
    {
        id: 'minecraft:waxed_exposed_cut_copper_slab',
        name: 'Waxed Exposed Cut Copper Slab',
    },
    {
        id: 'minecraft:waxed_weathered_cut_copper_slab',
        name: 'Waxed Weathered Cut Copper Slab',
    },
    {
        id: 'minecraft:waxed_oxidized_cut_copper_slab',
        name: 'Waxed Oxidized Cut Copper Slab',
    },
    {
        id: 'minecraft:oak_log',
        name: 'Oak Log',
    },
    {
        id: 'minecraft:spruce_log',
        name: 'Spruce Log',
    },
    {
        id: 'minecraft:birch_log',
        name: 'Birch Log',
    },
    {
        id: 'minecraft:jungle_log',
        name: 'Jungle Log',
    },
    {
        id: 'minecraft:acacia_log',
        name: 'Acacia Log',
    },
    {
        id: 'minecraft:cherry_log',
        name: 'Cherry Log',
    },
    {
        id: 'minecraft:pale_oak_log',
        name: 'Pale Oak Log',
    },
    {
        id: 'minecraft:dark_oak_log',
        name: 'Dark Oak Log',
    },
    {
        id: 'minecraft:mangrove_log',
        name: 'Mangrove Log',
    },
    {
        id: 'minecraft:mangrove_roots',
        name: 'Mangrove Roots',
    },
    {
        id: 'minecraft:muddy_mangrove_roots',
        name: 'Muddy Mangrove Roots',
    },
    {
        id: 'minecraft:crimson_stem',
        name: 'Crimson Stem',
    },
    {
        id: 'minecraft:warped_stem',
        name: 'Warped Stem',
    },
    {
        id: 'minecraft:bamboo_block',
        name: 'Block of Bamboo',
    },
    {
        id: 'minecraft:stripped_oak_log',
        name: 'Stripped Oak Log',
    },
    {
        id: 'minecraft:stripped_spruce_log',
        name: 'Stripped Spruce Log',
    },
    {
        id: 'minecraft:stripped_birch_log',
        name: 'Stripped Birch Log',
    },
    {
        id: 'minecraft:stripped_jungle_log',
        name: 'Stripped Jungle Log',
    },
    {
        id: 'minecraft:stripped_acacia_log',
        name: 'Stripped Acacia Log',
    },
    {
        id: 'minecraft:stripped_cherry_log',
        name: 'Stripped Cherry Log',
    },
    {
        id: 'minecraft:stripped_dark_oak_log',
        name: 'Stripped Dark Oak Log',
    },
    {
        id: 'minecraft:stripped_pale_oak_log',
        name: 'Stripped Pale Oak Log',
    },
    {
        id: 'minecraft:stripped_mangrove_log',
        name: 'Stripped Mangrove Log',
    },
    {
        id: 'minecraft:stripped_crimson_stem',
        name: 'Stripped Crimson Stem',
    },
    {
        id: 'minecraft:stripped_warped_stem',
        name: 'Stripped Warped Stem',
    },
    {
        id: 'minecraft:stripped_oak_wood',
        name: 'Stripped Oak Wood',
    },
    {
        id: 'minecraft:stripped_spruce_wood',
        name: 'Stripped Spruce Wood',
    },
    {
        id: 'minecraft:stripped_birch_wood',
        name: 'Stripped Birch Wood',
    },
    {
        id: 'minecraft:stripped_jungle_wood',
        name: 'Stripped Jungle Wood',
    },
    {
        id: 'minecraft:stripped_acacia_wood',
        name: 'Stripped Acacia Wood',
    },
    {
        id: 'minecraft:stripped_cherry_wood',
        name: 'Stripped Cherry Wood',
    },
    {
        id: 'minecraft:stripped_dark_oak_wood',
        name: 'Stripped Dark Oak Wood',
    },
    {
        id: 'minecraft:stripped_pale_oak_wood',
        name: 'Stripped Pale Oak Wood',
    },
    {
        id: 'minecraft:stripped_mangrove_wood',
        name: 'Stripped Mangrove Wood',
    },
    {
        id: 'minecraft:stripped_crimson_hyphae',
        name: 'Stripped Crimson Hyphae',
    },
    {
        id: 'minecraft:stripped_warped_hyphae',
        name: 'Stripped Warped Hyphae',
    },
    {
        id: 'minecraft:stripped_bamboo_block',
        name: 'Block of Stripped Bamboo',
    },
    {
        id: 'minecraft:oak_wood',
        name: 'Oak Wood',
    },
    {
        id: 'minecraft:spruce_wood',
        name: 'Spruce Wood',
    },
    {
        id: 'minecraft:birch_wood',
        name: 'Birch Wood',
    },
    {
        id: 'minecraft:jungle_wood',
        name: 'Jungle Wood',
    },
    {
        id: 'minecraft:acacia_wood',
        name: 'Acacia Wood',
    },
    {
        id: 'minecraft:cherry_wood',
        name: 'Cherry Wood',
    },
    {
        id: 'minecraft:pale_oak_wood',
        name: 'Pale Oak Wood',
    },
    {
        id: 'minecraft:dark_oak_wood',
        name: 'Dark Oak Wood',
    },
    {
        id: 'minecraft:mangrove_wood',
        name: 'Mangrove Wood',
    },
    {
        id: 'minecraft:crimson_hyphae',
        name: 'Crimson Hyphae',
    },
    {
        id: 'minecraft:warped_hyphae',
        name: 'Warped Hyphae',
    },
    {
        id: 'minecraft:oak_leaves',
        name: 'Oak Leaves',
    },
    {
        id: 'minecraft:spruce_leaves',
        name: 'Spruce Leaves',
    },
    {
        id: 'minecraft:birch_leaves',
        name: 'Birch Leaves',
    },
    {
        id: 'minecraft:jungle_leaves',
        name: 'Jungle Leaves',
    },
    {
        id: 'minecraft:acacia_leaves',
        name: 'Acacia Leaves',
    },
    {
        id: 'minecraft:cherry_leaves',
        name: 'Cherry Leaves',
    },
    {
        id: 'minecraft:dark_oak_leaves',
        name: 'Dark Oak Leaves',
    },
    {
        id: 'minecraft:pale_oak_leaves',
        name: 'Pale Oak Leaves',
    },
    {
        id: 'minecraft:mangrove_leaves',
        name: 'Mangrove Leaves',
    },
    {
        id: 'minecraft:azalea_leaves',
        name: 'Azalea Leaves',
    },
    {
        id: 'minecraft:flowering_azalea_leaves',
        name: 'Flowering Azalea Leaves',
    },
    {
        id: 'minecraft:sponge',
        name: 'Sponge',
    },
    {
        id: 'minecraft:wet_sponge',
        name: 'Wet Sponge',
    },
    {
        id: 'minecraft:glass',
        name: 'Glass',
    },
    {
        id: 'minecraft:tinted_glass',
        name: 'Tinted Glass',
    },
    {
        id: 'minecraft:lapis_block',
        name: 'Block of Lapis Lazuli',
    },
    {
        id: 'minecraft:sandstone',
        name: 'Sandstone',
    },
    {
        id: 'minecraft:chiseled_sandstone',
        name: 'Chiseled Sandstone',
    },
    {
        id: 'minecraft:cut_sandstone',
        name: 'Cut Sandstone',
    },
    {
        id: 'minecraft:cobweb',
        name: 'Cobweb',
    },
    {
        id: 'minecraft:short_grass',
        name: 'Short Grass',
    },
    {
        id: 'minecraft:fern',
        name: 'Fern',
    },
    {
        id: 'minecraft:bush',
        name: 'Bush',
    },
    {
        id: 'minecraft:azalea',
        name: 'Azalea',
    },
    {
        id: 'minecraft:flowering_azalea',
        name: 'Flowering Azalea',
    },
    {
        id: 'minecraft:dead_bush',
        name: 'Dead Bush',
    },
    {
        id: 'minecraft:firefly_bush',
        name: 'Firefly Bush',
    },
    {
        id: 'minecraft:short_dry_grass',
        name: 'Short Dry Grass',
    },
    {
        id: 'minecraft:tall_dry_grass',
        name: 'Tall Dry Grass',
    },
    {
        id: 'minecraft:seagrass',
        name: 'Seagrass',
    },
    {
        id: 'minecraft:sea_pickle',
        name: 'Sea Pickle',
    },
    {
        id: 'minecraft:white_wool',
        name: 'White Wool',
    },
    {
        id: 'minecraft:orange_wool',
        name: 'Orange Wool',
    },
    {
        id: 'minecraft:magenta_wool',
        name: 'Magenta Wool',
    },
    {
        id: 'minecraft:light_blue_wool',
        name: 'Light Blue Wool',
    },
    {
        id: 'minecraft:yellow_wool',
        name: 'Yellow Wool',
    },
    {
        id: 'minecraft:lime_wool',
        name: 'Lime Wool',
    },
    {
        id: 'minecraft:pink_wool',
        name: 'Pink Wool',
    },
    {
        id: 'minecraft:gray_wool',
        name: 'Gray Wool',
    },
    {
        id: 'minecraft:light_gray_wool',
        name: 'Light Gray Wool',
    },
    {
        id: 'minecraft:cyan_wool',
        name: 'Cyan Wool',
    },
    {
        id: 'minecraft:purple_wool',
        name: 'Purple Wool',
    },
    {
        id: 'minecraft:blue_wool',
        name: 'Blue Wool',
    },
    {
        id: 'minecraft:brown_wool',
        name: 'Brown Wool',
    },
    {
        id: 'minecraft:green_wool',
        name: 'Green Wool',
    },
    {
        id: 'minecraft:red_wool',
        name: 'Red Wool',
    },
    {
        id: 'minecraft:black_wool',
        name: 'Black Wool',
    },
    {
        id: 'minecraft:dandelion',
        name: 'Dandelion',
    },
    {
        id: 'minecraft:open_eyeblossom',
        name: 'Open Eyeblossom',
    },
    {
        id: 'minecraft:closed_eyeblossom',
        name: 'Closed Eyeblossom',
    },
    {
        id: 'minecraft:poppy',
        name: 'Poppy',
    },
    {
        id: 'minecraft:blue_orchid',
        name: 'Blue Orchid',
    },
    {
        id: 'minecraft:allium',
        name: 'Allium',
    },
    {
        id: 'minecraft:azure_bluet',
        name: 'Azure Bluet',
    },
    {
        id: 'minecraft:red_tulip',
        name: 'Red Tulip',
    },
    {
        id: 'minecraft:orange_tulip',
        name: 'Orange Tulip',
    },
    {
        id: 'minecraft:white_tulip',
        name: 'White Tulip',
    },
    {
        id: 'minecraft:pink_tulip',
        name: 'Pink Tulip',
    },
    {
        id: 'minecraft:oxeye_daisy',
        name: 'Oxeye Daisy',
    },
    {
        id: 'minecraft:cornflower',
        name: 'Cornflower',
    },
    {
        id: 'minecraft:lily_of_the_valley',
        name: 'Lily of the Valley',
    },
    {
        id: 'minecraft:wither_rose',
        name: 'Wither Rose',
    },
    {
        id: 'minecraft:torchflower',
        name: 'Torchflower',
    },
    {
        id: 'minecraft:pitcher_plant',
        name: 'Pitcher Plant',
    },
    {
        id: 'minecraft:spore_blossom',
        name: 'Spore Blossom',
    },
    {
        id: 'minecraft:brown_mushroom',
        name: 'Brown Mushroom',
    },
    {
        id: 'minecraft:red_mushroom',
        name: 'Red Mushroom',
    },
    {
        id: 'minecraft:crimson_fungus',
        name: 'Crimson Fungus',
    },
    {
        id: 'minecraft:warped_fungus',
        name: 'Warped Fungus',
    },
    {
        id: 'minecraft:crimson_roots',
        name: 'Crimson Roots',
    },
    {
        id: 'minecraft:warped_roots',
        name: 'Warped Roots',
    },
    {
        id: 'minecraft:nether_sprouts',
        name: 'Nether Sprouts',
    },
    {
        id: 'minecraft:weeping_vines',
        name: 'Weeping Vines',
    },
    {
        id: 'minecraft:twisting_vines',
        name: 'Twisting Vines',
    },
    {
        id: 'minecraft:sugar_cane',
        name: 'Sugar Cane',
    },
    {
        id: 'minecraft:kelp',
        name: 'Kelp',
    },
    {
        id: 'minecraft:pink_petals',
        name: 'Pink Petals',
    },
    {
        id: 'minecraft:wildflowers',
        name: 'Wildflowers',
    },
    {
        id: 'minecraft:leaf_litter',
        name: 'Leaf Litter',
    },
    {
        id: 'minecraft:moss_carpet',
        name: 'Moss Carpet',
    },
    {
        id: 'minecraft:moss_block',
        name: 'Moss Block',
    },
    {
        id: 'minecraft:pale_moss_carpet',
        name: 'Pale Moss Carpet',
    },
    {
        id: 'minecraft:pale_hanging_moss',
        name: 'Pale Hanging Moss',
    },
    {
        id: 'minecraft:pale_moss_block',
        name: 'Pale Moss Block',
    },
    {
        id: 'minecraft:hanging_roots',
        name: 'Hanging Roots',
    },
    {
        id: 'minecraft:big_dripleaf',
        name: 'Big Dripleaf',
    },
    {
        id: 'minecraft:small_dripleaf',
        name: 'Small Dripleaf',
    },
    {
        id: 'minecraft:bamboo',
        name: 'Bamboo',
    },
    {
        id: 'minecraft:oak_slab',
        name: 'Oak Slab',
    },
    {
        id: 'minecraft:spruce_slab',
        name: 'Spruce Slab',
    },
    {
        id: 'minecraft:birch_slab',
        name: 'Birch Slab',
    },
    {
        id: 'minecraft:jungle_slab',
        name: 'Jungle Slab',
    },
    {
        id: 'minecraft:acacia_slab',
        name: 'Acacia Slab',
    },
    {
        id: 'minecraft:cherry_slab',
        name: 'Cherry Slab',
    },
    {
        id: 'minecraft:dark_oak_slab',
        name: 'Dark Oak Slab',
    },
    {
        id: 'minecraft:pale_oak_slab',
        name: 'Pale Oak Slab',
    },
    {
        id: 'minecraft:mangrove_slab',
        name: 'Mangrove Slab',
    },
    {
        id: 'minecraft:bamboo_slab',
        name: 'Bamboo Slab',
    },
    {
        id: 'minecraft:bamboo_mosaic_slab',
        name: 'Bamboo Mosaic Slab',
    },
    {
        id: 'minecraft:crimson_slab',
        name: 'Crimson Slab',
    },
    {
        id: 'minecraft:warped_slab',
        name: 'Warped Slab',
    },
    {
        id: 'minecraft:stone_slab',
        name: 'Stone Slab',
    },
    {
        id: 'minecraft:smooth_stone_slab',
        name: 'Smooth Stone Slab',
    },
    {
        id: 'minecraft:sandstone_slab',
        name: 'Sandstone Slab',
    },
    {
        id: 'minecraft:cut_sandstone_slab',
        name: 'Cut Sandstone Slab',
    },
    {
        id: 'minecraft:petrified_oak_slab',
        name: 'Petrified Oak Slab',
    },
    {
        id: 'minecraft:cobblestone_slab',
        name: 'Cobblestone Slab',
    },
    {
        id: 'minecraft:brick_slab',
        name: 'Brick Slab',
    },
    {
        id: 'minecraft:stone_brick_slab',
        name: 'Stone Brick Slab',
    },
    {
        id: 'minecraft:mud_brick_slab',
        name: 'Mud Brick Slab',
    },
    {
        id: 'minecraft:nether_brick_slab',
        name: 'Nether Brick Slab',
    },
    {
        id: 'minecraft:quartz_slab',
        name: 'Quartz Slab',
    },
    {
        id: 'minecraft:red_sandstone_slab',
        name: 'Red Sandstone Slab',
    },
    {
        id: 'minecraft:cut_red_sandstone_slab',
        name: 'Cut Red Sandstone Slab',
    },
    {
        id: 'minecraft:purpur_slab',
        name: 'Purpur Slab',
    },
    {
        id: 'minecraft:prismarine_slab',
        name: 'Prismarine Slab',
    },
    {
        id: 'minecraft:prismarine_brick_slab',
        name: 'Prismarine Brick Slab',
    },
    {
        id: 'minecraft:dark_prismarine_slab',
        name: 'Dark Prismarine Slab',
    },
    {
        id: 'minecraft:smooth_quartz',
        name: 'Smooth Quartz Block',
    },
    {
        id: 'minecraft:smooth_red_sandstone',
        name: 'Smooth Red Sandstone',
    },
    {
        id: 'minecraft:smooth_sandstone',
        name: 'Smooth Sandstone',
    },
    {
        id: 'minecraft:smooth_stone',
        name: 'Smooth Stone',
    },
    {
        id: 'minecraft:bricks',
        name: 'Bricks',
    },
    {
        id: 'minecraft:acacia_shelf',
        name: 'Acacia Shelf',
    },
    {
        id: 'minecraft:bamboo_shelf',
        name: 'Bamboo Shelf',
    },
    {
        id: 'minecraft:birch_shelf',
        name: 'Birch Shelf',
    },
    {
        id: 'minecraft:cherry_shelf',
        name: 'Cherry Shelf',
    },
    {
        id: 'minecraft:crimson_shelf',
        name: 'Crimson Shelf',
    },
    {
        id: 'minecraft:dark_oak_shelf',
        name: 'Dark Oak Shelf',
    },
    {
        id: 'minecraft:jungle_shelf',
        name: 'Jungle Shelf',
    },
    {
        id: 'minecraft:mangrove_shelf',
        name: 'Mangrove Shelf',
    },
    {
        id: 'minecraft:oak_shelf',
        name: 'Oak Shelf',
    },
    {
        id: 'minecraft:pale_oak_shelf',
        name: 'Pale Oak Shelf',
    },
    {
        id: 'minecraft:spruce_shelf',
        name: 'Spruce Shelf',
    },
    {
        id: 'minecraft:warped_shelf',
        name: 'Warped Shelf',
    },
    {
        id: 'minecraft:bookshelf',
        name: 'Bookshelf',
    },
    {
        id: 'minecraft:chiseled_bookshelf',
        name: 'Chiseled Bookshelf',
    },
    {
        id: 'minecraft:decorated_pot',
        name: 'Decorated Pot',
    },
    {
        id: 'minecraft:mossy_cobblestone',
        name: 'Mossy Cobblestone',
    },
    {
        id: 'minecraft:obsidian',
        name: 'Obsidian',
    },
    {
        id: 'minecraft:torch',
        name: 'Torch',
    },
    {
        id: 'minecraft:end_rod',
        name: 'End Rod',
    },
    {
        id: 'minecraft:chorus_plant',
        name: 'Chorus Plant',
    },
    {
        id: 'minecraft:chorus_flower',
        name: 'Chorus Flower',
    },
    {
        id: 'minecraft:purpur_block',
        name: 'Purpur Block',
    },
    {
        id: 'minecraft:purpur_pillar',
        name: 'Purpur Pillar',
    },
    {
        id: 'minecraft:purpur_stairs',
        name: 'Purpur Stairs',
    },
    {
        id: 'minecraft:spawner',
        name: 'Monster Spawner',
    },
    {
        id: 'minecraft:creaking_heart',
        name: 'Creaking Heart',
    },
    {
        id: 'minecraft:chest',
        name: 'Chest',
    },
    {
        id: 'minecraft:crafting_table',
        name: 'Crafting Table',
    },
    {
        id: 'minecraft:farmland',
        name: 'Farmland',
    },
    {
        id: 'minecraft:furnace',
        name: 'Furnace',
    },
    {
        id: 'minecraft:ladder',
        name: 'Ladder',
    },
    {
        id: 'minecraft:cobblestone_stairs',
        name: 'Cobblestone Stairs',
    },
    {
        id: 'minecraft:snow',
        name: 'Snow',
    },
    {
        id: 'minecraft:ice',
        name: 'Ice',
    },
    {
        id: 'minecraft:snow_block',
        name: 'Snow Block',
    },
    {
        id: 'minecraft:cactus',
        name: 'Cactus',
    },
    {
        id: 'minecraft:cactus_flower',
        name: 'Cactus Flower',
    },
    {
        id: 'minecraft:clay',
        name: 'Clay',
    },
    {
        id: 'minecraft:jukebox',
        name: 'Jukebox',
    },
    {
        id: 'minecraft:oak_fence',
        name: 'Oak Fence',
    },
    {
        id: 'minecraft:spruce_fence',
        name: 'Spruce Fence',
    },
    {
        id: 'minecraft:birch_fence',
        name: 'Birch Fence',
    },
    {
        id: 'minecraft:jungle_fence',
        name: 'Jungle Fence',
    },
    {
        id: 'minecraft:acacia_fence',
        name: 'Acacia Fence',
    },
    {
        id: 'minecraft:cherry_fence',
        name: 'Cherry Fence',
    },
    {
        id: 'minecraft:dark_oak_fence',
        name: 'Dark Oak Fence',
    },
    {
        id: 'minecraft:pale_oak_fence',
        name: 'Pale Oak Fence',
    },
    {
        id: 'minecraft:mangrove_fence',
        name: 'Mangrove Fence',
    },
    {
        id: 'minecraft:bamboo_fence',
        name: 'Bamboo Fence',
    },
    {
        id: 'minecraft:crimson_fence',
        name: 'Crimson Fence',
    },
    {
        id: 'minecraft:warped_fence',
        name: 'Warped Fence',
    },
    {
        id: 'minecraft:pumpkin',
        name: 'Pumpkin',
    },
    {
        id: 'minecraft:carved_pumpkin',
        name: 'Carved Pumpkin',
    },
    {
        id: 'minecraft:jack_o_lantern',
        name: "Jack o'Lantern",
    },
    {
        id: 'minecraft:netherrack',
        name: 'Netherrack',
    },
    {
        id: 'minecraft:soul_sand',
        name: 'Soul Sand',
    },
    {
        id: 'minecraft:soul_soil',
        name: 'Soul Soil',
    },
    {
        id: 'minecraft:basalt',
        name: 'Basalt',
    },
    {
        id: 'minecraft:polished_basalt',
        name: 'Polished Basalt',
    },
    {
        id: 'minecraft:smooth_basalt',
        name: 'Smooth Basalt',
    },
    {
        id: 'minecraft:soul_torch',
        name: 'Soul Torch',
    },
    {
        id: 'minecraft:copper_torch',
        name: 'Copper Torch',
    },
    {
        id: 'minecraft:glowstone',
        name: 'Glowstone',
    },
    {
        id: 'minecraft:infested_stone',
        name: 'Infested Stone',
    },
    {
        id: 'minecraft:infested_cobblestone',
        name: 'Infested Cobblestone',
    },
    {
        id: 'minecraft:infested_stone_bricks',
        name: 'Infested Stone Bricks',
    },
    {
        id: 'minecraft:infested_mossy_stone_bricks',
        name: 'Infested Mossy Stone Bricks',
    },
    {
        id: 'minecraft:infested_cracked_stone_bricks',
        name: 'Infested Cracked Stone Bricks',
    },
    {
        id: 'minecraft:infested_chiseled_stone_bricks',
        name: 'Infested Chiseled Stone Bricks',
    },
    {
        id: 'minecraft:infested_deepslate',
        name: 'Infested Deepslate',
    },
    {
        id: 'minecraft:stone_bricks',
        name: 'Stone Bricks',
    },
    {
        id: 'minecraft:mossy_stone_bricks',
        name: 'Mossy Stone Bricks',
    },
    {
        id: 'minecraft:cracked_stone_bricks',
        name: 'Cracked Stone Bricks',
    },
    {
        id: 'minecraft:chiseled_stone_bricks',
        name: 'Chiseled Stone Bricks',
    },
    {
        id: 'minecraft:packed_mud',
        name: 'Packed Mud',
    },
    {
        id: 'minecraft:mud_bricks',
        name: 'Mud Bricks',
    },
    {
        id: 'minecraft:deepslate_bricks',
        name: 'Deepslate Bricks',
    },
    {
        id: 'minecraft:cracked_deepslate_bricks',
        name: 'Cracked Deepslate Bricks',
    },
    {
        id: 'minecraft:deepslate_tiles',
        name: 'Deepslate Tiles',
    },
    {
        id: 'minecraft:cracked_deepslate_tiles',
        name: 'Cracked Deepslate Tiles',
    },
    {
        id: 'minecraft:chiseled_deepslate',
        name: 'Chiseled Deepslate',
    },
    {
        id: 'minecraft:reinforced_deepslate',
        name: 'Reinforced Deepslate',
    },
    {
        id: 'minecraft:brown_mushroom_block',
        name: 'Brown Mushroom Block',
    },
    {
        id: 'minecraft:red_mushroom_block',
        name: 'Red Mushroom Block',
    },
    {
        id: 'minecraft:mushroom_stem',
        name: 'Mushroom Stem',
    },
    {
        id: 'minecraft:iron_bars',
        name: 'Iron Bars',
    },
    {
        id: 'minecraft:copper_bars',
        name: 'Copper Bars',
    },
    {
        id: 'minecraft:exposed_copper_bars',
        name: 'Exposed Copper Bars',
    },
    {
        id: 'minecraft:weathered_copper_bars',
        name: 'Weathered Copper Bars',
    },
    {
        id: 'minecraft:oxidized_copper_bars',
        name: 'Oxidized Copper Bars',
    },
    {
        id: 'minecraft:waxed_copper_bars',
        name: 'Waxed Copper Bars',
    },
    {
        id: 'minecraft:waxed_exposed_copper_bars',
        name: 'Waxed Exposed Copper Bars',
    },
    {
        id: 'minecraft:waxed_weathered_copper_bars',
        name: 'Waxed Weathered Copper Bars',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_bars',
        name: 'Waxed Oxidized Copper Bars',
    },
    {
        id: 'minecraft:iron_chain',
        name: 'Iron Chain',
    },
    {
        id: 'minecraft:copper_chain',
        name: 'Copper Chain',
    },
    {
        id: 'minecraft:exposed_copper_chain',
        name: 'Exposed Copper Chain',
    },
    {
        id: 'minecraft:weathered_copper_chain',
        name: 'Weathered Copper Chain',
    },
    {
        id: 'minecraft:oxidized_copper_chain',
        name: 'Oxidized Copper Chain',
    },
    {
        id: 'minecraft:waxed_copper_chain',
        name: 'Waxed Copper Chain',
    },
    {
        id: 'minecraft:waxed_exposed_copper_chain',
        name: 'Waxed Exposed Copper Chain',
    },
    {
        id: 'minecraft:waxed_weathered_copper_chain',
        name: 'Waxed Weathered Copper Chain',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_chain',
        name: 'Waxed Oxidized Copper Chain',
    },
    {
        id: 'minecraft:glass_pane',
        name: 'Glass Pane',
    },
    {
        id: 'minecraft:melon',
        name: 'Melon',
    },
    {
        id: 'minecraft:vine',
        name: 'Vines',
    },
    {
        id: 'minecraft:glow_lichen',
        name: 'Glow Lichen',
    },
    {
        id: 'minecraft:resin_clump',
        name: 'Resin Clump',
    },
    {
        id: 'minecraft:resin_block',
        name: 'Block of Resin',
    },
    {
        id: 'minecraft:resin_bricks',
        name: 'Resin Bricks',
    },
    {
        id: 'minecraft:resin_brick_stairs',
        name: 'Resin Brick Stairs',
    },
    {
        id: 'minecraft:resin_brick_slab',
        name: 'Resin Brick Slab',
    },
    {
        id: 'minecraft:resin_brick_wall',
        name: 'Resin Brick Wall',
    },
    {
        id: 'minecraft:chiseled_resin_bricks',
        name: 'Chiseled Resin Bricks',
    },
    {
        id: 'minecraft:brick_stairs',
        name: 'Brick Stairs',
    },
    {
        id: 'minecraft:stone_brick_stairs',
        name: 'Stone Brick Stairs',
    },
    {
        id: 'minecraft:mud_brick_stairs',
        name: 'Mud Brick Stairs',
    },
    {
        id: 'minecraft:mycelium',
        name: 'Mycelium',
    },
    {
        id: 'minecraft:lily_pad',
        name: 'Lily Pad',
    },
    {
        id: 'minecraft:nether_bricks',
        name: 'Nether Bricks',
    },
    {
        id: 'minecraft:cracked_nether_bricks',
        name: 'Cracked Nether Bricks',
    },
    {
        id: 'minecraft:chiseled_nether_bricks',
        name: 'Chiseled Nether Bricks',
    },
    {
        id: 'minecraft:nether_brick_fence',
        name: 'Nether Brick Fence',
    },
    {
        id: 'minecraft:nether_brick_stairs',
        name: 'Nether Brick Stairs',
    },
    {
        id: 'minecraft:sculk',
        name: 'Sculk',
    },
    {
        id: 'minecraft:sculk_vein',
        name: 'Sculk Vein',
    },
    {
        id: 'minecraft:sculk_catalyst',
        name: 'Sculk Catalyst',
    },
    {
        id: 'minecraft:sculk_shrieker',
        name: 'Sculk Shrieker',
    },
    {
        id: 'minecraft:enchanting_table',
        name: 'Enchanting Table',
    },
    {
        id: 'minecraft:end_portal_frame',
        name: 'End Portal Frame',
    },
    {
        id: 'minecraft:end_stone',
        name: 'End Stone',
    },
    {
        id: 'minecraft:end_stone_bricks',
        name: 'End Stone Bricks',
    },
    {
        id: 'minecraft:dragon_egg',
        name: 'Dragon Egg',
    },
    {
        id: 'minecraft:sandstone_stairs',
        name: 'Sandstone Stairs',
    },
    {
        id: 'minecraft:ender_chest',
        name: 'Ender Chest',
    },
    {
        id: 'minecraft:emerald_block',
        name: 'Block of Emerald',
    },
    {
        id: 'minecraft:oak_stairs',
        name: 'Oak Stairs',
    },
    {
        id: 'minecraft:spruce_stairs',
        name: 'Spruce Stairs',
    },
    {
        id: 'minecraft:birch_stairs',
        name: 'Birch Stairs',
    },
    {
        id: 'minecraft:jungle_stairs',
        name: 'Jungle Stairs',
    },
    {
        id: 'minecraft:acacia_stairs',
        name: 'Acacia Stairs',
    },
    {
        id: 'minecraft:cherry_stairs',
        name: 'Cherry Stairs',
    },
    {
        id: 'minecraft:dark_oak_stairs',
        name: 'Dark Oak Stairs',
    },
    {
        id: 'minecraft:pale_oak_stairs',
        name: 'Pale Oak Stairs',
    },
    {
        id: 'minecraft:mangrove_stairs',
        name: 'Mangrove Stairs',
    },
    {
        id: 'minecraft:bamboo_stairs',
        name: 'Bamboo Stairs',
    },
    {
        id: 'minecraft:bamboo_mosaic_stairs',
        name: 'Bamboo Mosaic Stairs',
    },
    {
        id: 'minecraft:crimson_stairs',
        name: 'Crimson Stairs',
    },
    {
        id: 'minecraft:warped_stairs',
        name: 'Warped Stairs',
    },
    {
        id: 'minecraft:command_block',
        name: 'Command Block',
    },
    {
        id: 'minecraft:beacon',
        name: 'Beacon',
    },
    {
        id: 'minecraft:cobblestone_wall',
        name: 'Cobblestone Wall',
    },
    {
        id: 'minecraft:mossy_cobblestone_wall',
        name: 'Mossy Cobblestone Wall',
    },
    {
        id: 'minecraft:brick_wall',
        name: 'Brick Wall',
    },
    {
        id: 'minecraft:prismarine_wall',
        name: 'Prismarine Wall',
    },
    {
        id: 'minecraft:red_sandstone_wall',
        name: 'Red Sandstone Wall',
    },
    {
        id: 'minecraft:mossy_stone_brick_wall',
        name: 'Mossy Stone Brick Wall',
    },
    {
        id: 'minecraft:granite_wall',
        name: 'Granite Wall',
    },
    {
        id: 'minecraft:stone_brick_wall',
        name: 'Stone Brick Wall',
    },
    {
        id: 'minecraft:mud_brick_wall',
        name: 'Mud Brick Wall',
    },
    {
        id: 'minecraft:nether_brick_wall',
        name: 'Nether Brick Wall',
    },
    {
        id: 'minecraft:andesite_wall',
        name: 'Andesite Wall',
    },
    {
        id: 'minecraft:red_nether_brick_wall',
        name: 'Red Nether Brick Wall',
    },
    {
        id: 'minecraft:sandstone_wall',
        name: 'Sandstone Wall',
    },
    {
        id: 'minecraft:end_stone_brick_wall',
        name: 'End Stone Brick Wall',
    },
    {
        id: 'minecraft:diorite_wall',
        name: 'Diorite Wall',
    },
    {
        id: 'minecraft:blackstone_wall',
        name: 'Blackstone Wall',
    },
    {
        id: 'minecraft:polished_blackstone_wall',
        name: 'Polished Blackstone Wall',
    },
    {
        id: 'minecraft:polished_blackstone_brick_wall',
        name: 'Polished Blackstone Brick Wall',
    },
    {
        id: 'minecraft:cobbled_deepslate_wall',
        name: 'Cobbled Deepslate Wall',
    },
    {
        id: 'minecraft:polished_deepslate_wall',
        name: 'Polished Deepslate Wall',
    },
    {
        id: 'minecraft:deepslate_brick_wall',
        name: 'Deepslate Brick Wall',
    },
    {
        id: 'minecraft:deepslate_tile_wall',
        name: 'Deepslate Tile Wall',
    },
    {
        id: 'minecraft:anvil',
        name: 'Anvil',
    },
    {
        id: 'minecraft:chipped_anvil',
        name: 'Chipped Anvil',
    },
    {
        id: 'minecraft:damaged_anvil',
        name: 'Damaged Anvil',
    },
    {
        id: 'minecraft:chiseled_quartz_block',
        name: 'Chiseled Quartz Block',
    },
    {
        id: 'minecraft:quartz_block',
        name: 'Block of Quartz',
    },
    {
        id: 'minecraft:quartz_bricks',
        name: 'Quartz Bricks',
    },
    {
        id: 'minecraft:quartz_pillar',
        name: 'Quartz Pillar',
    },
    {
        id: 'minecraft:quartz_stairs',
        name: 'Quartz Stairs',
    },
    {
        id: 'minecraft:white_terracotta',
        name: 'White Terracotta',
    },
    {
        id: 'minecraft:orange_terracotta',
        name: 'Orange Terracotta',
    },
    {
        id: 'minecraft:magenta_terracotta',
        name: 'Magenta Terracotta',
    },
    {
        id: 'minecraft:light_blue_terracotta',
        name: 'Light Blue Terracotta',
    },
    {
        id: 'minecraft:yellow_terracotta',
        name: 'Yellow Terracotta',
    },
    {
        id: 'minecraft:lime_terracotta',
        name: 'Lime Terracotta',
    },
    {
        id: 'minecraft:pink_terracotta',
        name: 'Pink Terracotta',
    },
    {
        id: 'minecraft:gray_terracotta',
        name: 'Gray Terracotta',
    },
    {
        id: 'minecraft:light_gray_terracotta',
        name: 'Light Gray Terracotta',
    },
    {
        id: 'minecraft:cyan_terracotta',
        name: 'Cyan Terracotta',
    },
    {
        id: 'minecraft:purple_terracotta',
        name: 'Purple Terracotta',
    },
    {
        id: 'minecraft:blue_terracotta',
        name: 'Blue Terracotta',
    },
    {
        id: 'minecraft:brown_terracotta',
        name: 'Brown Terracotta',
    },
    {
        id: 'minecraft:green_terracotta',
        name: 'Green Terracotta',
    },
    {
        id: 'minecraft:red_terracotta',
        name: 'Red Terracotta',
    },
    {
        id: 'minecraft:black_terracotta',
        name: 'Black Terracotta',
    },
    {
        id: 'minecraft:barrier',
        name: 'Barrier',
    },
    {
        id: 'minecraft:light',
        name: 'Light',
    },
    {
        id: 'minecraft:hay_block',
        name: 'Hay Bale',
    },
    {
        id: 'minecraft:white_carpet',
        name: 'White Carpet',
    },
    {
        id: 'minecraft:orange_carpet',
        name: 'Orange Carpet',
    },
    {
        id: 'minecraft:magenta_carpet',
        name: 'Magenta Carpet',
    },
    {
        id: 'minecraft:light_blue_carpet',
        name: 'Light Blue Carpet',
    },
    {
        id: 'minecraft:yellow_carpet',
        name: 'Yellow Carpet',
    },
    {
        id: 'minecraft:lime_carpet',
        name: 'Lime Carpet',
    },
    {
        id: 'minecraft:pink_carpet',
        name: 'Pink Carpet',
    },
    {
        id: 'minecraft:gray_carpet',
        name: 'Gray Carpet',
    },
    {
        id: 'minecraft:light_gray_carpet',
        name: 'Light Gray Carpet',
    },
    {
        id: 'minecraft:cyan_carpet',
        name: 'Cyan Carpet',
    },
    {
        id: 'minecraft:purple_carpet',
        name: 'Purple Carpet',
    },
    {
        id: 'minecraft:blue_carpet',
        name: 'Blue Carpet',
    },
    {
        id: 'minecraft:brown_carpet',
        name: 'Brown Carpet',
    },
    {
        id: 'minecraft:green_carpet',
        name: 'Green Carpet',
    },
    {
        id: 'minecraft:red_carpet',
        name: 'Red Carpet',
    },
    {
        id: 'minecraft:black_carpet',
        name: 'Black Carpet',
    },
    {
        id: 'minecraft:terracotta',
        name: 'Terracotta',
    },
    {
        id: 'minecraft:packed_ice',
        name: 'Packed Ice',
    },
    {
        id: 'minecraft:dirt_path',
        name: 'Dirt Path',
    },
    {
        id: 'minecraft:sunflower',
        name: 'Sunflower',
    },
    {
        id: 'minecraft:lilac',
        name: 'Lilac',
    },
    {
        id: 'minecraft:rose_bush',
        name: 'Rose Bush',
    },
    {
        id: 'minecraft:peony',
        name: 'Peony',
    },
    {
        id: 'minecraft:tall_grass',
        name: 'Tall Grass',
    },
    {
        id: 'minecraft:large_fern',
        name: 'Large Fern',
    },
    {
        id: 'minecraft:white_stained_glass',
        name: 'White Stained Glass',
    },
    {
        id: 'minecraft:orange_stained_glass',
        name: 'Orange Stained Glass',
    },
    {
        id: 'minecraft:magenta_stained_glass',
        name: 'Magenta Stained Glass',
    },
    {
        id: 'minecraft:light_blue_stained_glass',
        name: 'Light Blue Stained Glass',
    },
    {
        id: 'minecraft:yellow_stained_glass',
        name: 'Yellow Stained Glass',
    },
    {
        id: 'minecraft:lime_stained_glass',
        name: 'Lime Stained Glass',
    },
    {
        id: 'minecraft:pink_stained_glass',
        name: 'Pink Stained Glass',
    },
    {
        id: 'minecraft:gray_stained_glass',
        name: 'Gray Stained Glass',
    },
    {
        id: 'minecraft:light_gray_stained_glass',
        name: 'Light Gray Stained Glass',
    },
    {
        id: 'minecraft:cyan_stained_glass',
        name: 'Cyan Stained Glass',
    },
    {
        id: 'minecraft:purple_stained_glass',
        name: 'Purple Stained Glass',
    },
    {
        id: 'minecraft:blue_stained_glass',
        name: 'Blue Stained Glass',
    },
    {
        id: 'minecraft:brown_stained_glass',
        name: 'Brown Stained Glass',
    },
    {
        id: 'minecraft:green_stained_glass',
        name: 'Green Stained Glass',
    },
    {
        id: 'minecraft:red_stained_glass',
        name: 'Red Stained Glass',
    },
    {
        id: 'minecraft:black_stained_glass',
        name: 'Black Stained Glass',
    },
    {
        id: 'minecraft:white_stained_glass_pane',
        name: 'White Stained Glass Pane',
    },
    {
        id: 'minecraft:orange_stained_glass_pane',
        name: 'Orange Stained Glass Pane',
    },
    {
        id: 'minecraft:magenta_stained_glass_pane',
        name: 'Magenta Stained Glass Pane',
    },
    {
        id: 'minecraft:light_blue_stained_glass_pane',
        name: 'Light Blue Stained Glass Pane',
    },
    {
        id: 'minecraft:yellow_stained_glass_pane',
        name: 'Yellow Stained Glass Pane',
    },
    {
        id: 'minecraft:lime_stained_glass_pane',
        name: 'Lime Stained Glass Pane',
    },
    {
        id: 'minecraft:pink_stained_glass_pane',
        name: 'Pink Stained Glass Pane',
    },
    {
        id: 'minecraft:gray_stained_glass_pane',
        name: 'Gray Stained Glass Pane',
    },
    {
        id: 'minecraft:light_gray_stained_glass_pane',
        name: 'Light Gray Stained Glass Pane',
    },
    {
        id: 'minecraft:cyan_stained_glass_pane',
        name: 'Cyan Stained Glass Pane',
    },
    {
        id: 'minecraft:purple_stained_glass_pane',
        name: 'Purple Stained Glass Pane',
    },
    {
        id: 'minecraft:blue_stained_glass_pane',
        name: 'Blue Stained Glass Pane',
    },
    {
        id: 'minecraft:brown_stained_glass_pane',
        name: 'Brown Stained Glass Pane',
    },
    {
        id: 'minecraft:green_stained_glass_pane',
        name: 'Green Stained Glass Pane',
    },
    {
        id: 'minecraft:red_stained_glass_pane',
        name: 'Red Stained Glass Pane',
    },
    {
        id: 'minecraft:black_stained_glass_pane',
        name: 'Black Stained Glass Pane',
    },
    {
        id: 'minecraft:prismarine',
        name: 'Prismarine',
    },
    {
        id: 'minecraft:prismarine_bricks',
        name: 'Prismarine Bricks',
    },
    {
        id: 'minecraft:dark_prismarine',
        name: 'Dark Prismarine',
    },
    {
        id: 'minecraft:prismarine_stairs',
        name: 'Prismarine Stairs',
    },
    {
        id: 'minecraft:prismarine_brick_stairs',
        name: 'Prismarine Brick Stairs',
    },
    {
        id: 'minecraft:dark_prismarine_stairs',
        name: 'Dark Prismarine Stairs',
    },
    {
        id: 'minecraft:sea_lantern',
        name: 'Sea Lantern',
    },
    {
        id: 'minecraft:red_sandstone',
        name: 'Red Sandstone',
    },
    {
        id: 'minecraft:chiseled_red_sandstone',
        name: 'Chiseled Red Sandstone',
    },
    {
        id: 'minecraft:cut_red_sandstone',
        name: 'Cut Red Sandstone',
    },
    {
        id: 'minecraft:red_sandstone_stairs',
        name: 'Red Sandstone Stairs',
    },
    {
        id: 'minecraft:repeating_command_block',
        name: 'Repeating Command Block',
    },
    {
        id: 'minecraft:chain_command_block',
        name: 'Chain Command Block',
    },
    {
        id: 'minecraft:magma_block',
        name: 'Magma Block',
    },
    {
        id: 'minecraft:nether_wart_block',
        name: 'Nether Wart Block',
    },
    {
        id: 'minecraft:warped_wart_block',
        name: 'Warped Wart Block',
    },
    {
        id: 'minecraft:red_nether_bricks',
        name: 'Red Nether Bricks',
    },
    {
        id: 'minecraft:bone_block',
        name: 'Bone Block',
    },
    {
        id: 'minecraft:structure_void',
        name: 'Structure Void',
    },
    {
        id: 'minecraft:shulker_box',
        name: 'Shulker Box',
    },
    {
        id: 'minecraft:white_shulker_box',
        name: 'White Shulker Box',
    },
    {
        id: 'minecraft:orange_shulker_box',
        name: 'Orange Shulker Box',
    },
    {
        id: 'minecraft:magenta_shulker_box',
        name: 'Magenta Shulker Box',
    },
    {
        id: 'minecraft:light_blue_shulker_box',
        name: 'Light Blue Shulker Box',
    },
    {
        id: 'minecraft:yellow_shulker_box',
        name: 'Yellow Shulker Box',
    },
    {
        id: 'minecraft:lime_shulker_box',
        name: 'Lime Shulker Box',
    },
    {
        id: 'minecraft:pink_shulker_box',
        name: 'Pink Shulker Box',
    },
    {
        id: 'minecraft:gray_shulker_box',
        name: 'Gray Shulker Box',
    },
    {
        id: 'minecraft:light_gray_shulker_box',
        name: 'Light Gray Shulker Box',
    },
    {
        id: 'minecraft:cyan_shulker_box',
        name: 'Cyan Shulker Box',
    },
    {
        id: 'minecraft:purple_shulker_box',
        name: 'Purple Shulker Box',
    },
    {
        id: 'minecraft:blue_shulker_box',
        name: 'Blue Shulker Box',
    },
    {
        id: 'minecraft:brown_shulker_box',
        name: 'Brown Shulker Box',
    },
    {
        id: 'minecraft:green_shulker_box',
        name: 'Green Shulker Box',
    },
    {
        id: 'minecraft:red_shulker_box',
        name: 'Red Shulker Box',
    },
    {
        id: 'minecraft:black_shulker_box',
        name: 'Black Shulker Box',
    },
    {
        id: 'minecraft:white_glazed_terracotta',
        name: 'White Glazed Terracotta',
    },
    {
        id: 'minecraft:orange_glazed_terracotta',
        name: 'Orange Glazed Terracotta',
    },
    {
        id: 'minecraft:magenta_glazed_terracotta',
        name: 'Magenta Glazed Terracotta',
    },
    {
        id: 'minecraft:light_blue_glazed_terracotta',
        name: 'Light Blue Glazed Terracotta',
    },
    {
        id: 'minecraft:yellow_glazed_terracotta',
        name: 'Yellow Glazed Terracotta',
    },
    {
        id: 'minecraft:lime_glazed_terracotta',
        name: 'Lime Glazed Terracotta',
    },
    {
        id: 'minecraft:pink_glazed_terracotta',
        name: 'Pink Glazed Terracotta',
    },
    {
        id: 'minecraft:gray_glazed_terracotta',
        name: 'Gray Glazed Terracotta',
    },
    {
        id: 'minecraft:light_gray_glazed_terracotta',
        name: 'Light Gray Glazed Terracotta',
    },
    {
        id: 'minecraft:cyan_glazed_terracotta',
        name: 'Cyan Glazed Terracotta',
    },
    {
        id: 'minecraft:purple_glazed_terracotta',
        name: 'Purple Glazed Terracotta',
    },
    {
        id: 'minecraft:blue_glazed_terracotta',
        name: 'Blue Glazed Terracotta',
    },
    {
        id: 'minecraft:brown_glazed_terracotta',
        name: 'Brown Glazed Terracotta',
    },
    {
        id: 'minecraft:green_glazed_terracotta',
        name: 'Green Glazed Terracotta',
    },
    {
        id: 'minecraft:red_glazed_terracotta',
        name: 'Red Glazed Terracotta',
    },
    {
        id: 'minecraft:black_glazed_terracotta',
        name: 'Black Glazed Terracotta',
    },
    {
        id: 'minecraft:white_concrete',
        name: 'White Concrete',
    },
    {
        id: 'minecraft:orange_concrete',
        name: 'Orange Concrete',
    },
    {
        id: 'minecraft:magenta_concrete',
        name: 'Magenta Concrete',
    },
    {
        id: 'minecraft:light_blue_concrete',
        name: 'Light Blue Concrete',
    },
    {
        id: 'minecraft:yellow_concrete',
        name: 'Yellow Concrete',
    },
    {
        id: 'minecraft:lime_concrete',
        name: 'Lime Concrete',
    },
    {
        id: 'minecraft:pink_concrete',
        name: 'Pink Concrete',
    },
    {
        id: 'minecraft:gray_concrete',
        name: 'Gray Concrete',
    },
    {
        id: 'minecraft:light_gray_concrete',
        name: 'Light Gray Concrete',
    },
    {
        id: 'minecraft:cyan_concrete',
        name: 'Cyan Concrete',
    },
    {
        id: 'minecraft:purple_concrete',
        name: 'Purple Concrete',
    },
    {
        id: 'minecraft:blue_concrete',
        name: 'Blue Concrete',
    },
    {
        id: 'minecraft:brown_concrete',
        name: 'Brown Concrete',
    },
    {
        id: 'minecraft:green_concrete',
        name: 'Green Concrete',
    },
    {
        id: 'minecraft:red_concrete',
        name: 'Red Concrete',
    },
    {
        id: 'minecraft:black_concrete',
        name: 'Black Concrete',
    },
    {
        id: 'minecraft:white_concrete_powder',
        name: 'White Concrete Powder',
    },
    {
        id: 'minecraft:orange_concrete_powder',
        name: 'Orange Concrete Powder',
    },
    {
        id: 'minecraft:magenta_concrete_powder',
        name: 'Magenta Concrete Powder',
    },
    {
        id: 'minecraft:light_blue_concrete_powder',
        name: 'Light Blue Concrete Powder',
    },
    {
        id: 'minecraft:yellow_concrete_powder',
        name: 'Yellow Concrete Powder',
    },
    {
        id: 'minecraft:lime_concrete_powder',
        name: 'Lime Concrete Powder',
    },
    {
        id: 'minecraft:pink_concrete_powder',
        name: 'Pink Concrete Powder',
    },
    {
        id: 'minecraft:gray_concrete_powder',
        name: 'Gray Concrete Powder',
    },
    {
        id: 'minecraft:light_gray_concrete_powder',
        name: 'Light Gray Concrete Powder',
    },
    {
        id: 'minecraft:cyan_concrete_powder',
        name: 'Cyan Concrete Powder',
    },
    {
        id: 'minecraft:purple_concrete_powder',
        name: 'Purple Concrete Powder',
    },
    {
        id: 'minecraft:blue_concrete_powder',
        name: 'Blue Concrete Powder',
    },
    {
        id: 'minecraft:brown_concrete_powder',
        name: 'Brown Concrete Powder',
    },
    {
        id: 'minecraft:green_concrete_powder',
        name: 'Green Concrete Powder',
    },
    {
        id: 'minecraft:red_concrete_powder',
        name: 'Red Concrete Powder',
    },
    {
        id: 'minecraft:black_concrete_powder',
        name: 'Black Concrete Powder',
    },
    {
        id: 'minecraft:turtle_egg',
        name: 'Turtle Egg',
    },
    {
        id: 'minecraft:sniffer_egg',
        name: 'Sniffer Egg',
    },
    {
        id: 'minecraft:dried_ghast',
        name: 'Dried Ghast',
    },
    {
        id: 'minecraft:dead_tube_coral_block',
        name: 'Dead Tube Coral Block',
    },
    {
        id: 'minecraft:dead_brain_coral_block',
        name: 'Dead Brain Coral Block',
    },
    {
        id: 'minecraft:dead_bubble_coral_block',
        name: 'Dead Bubble Coral Block',
    },
    {
        id: 'minecraft:dead_fire_coral_block',
        name: 'Dead Fire Coral Block',
    },
    {
        id: 'minecraft:dead_horn_coral_block',
        name: 'Dead Horn Coral Block',
    },
    {
        id: 'minecraft:tube_coral_block',
        name: 'Tube Coral Block',
    },
    {
        id: 'minecraft:brain_coral_block',
        name: 'Brain Coral Block',
    },
    {
        id: 'minecraft:bubble_coral_block',
        name: 'Bubble Coral Block',
    },
    {
        id: 'minecraft:fire_coral_block',
        name: 'Fire Coral Block',
    },
    {
        id: 'minecraft:horn_coral_block',
        name: 'Horn Coral Block',
    },
    {
        id: 'minecraft:tube_coral',
        name: 'Tube Coral',
    },
    {
        id: 'minecraft:brain_coral',
        name: 'Brain Coral',
    },
    {
        id: 'minecraft:bubble_coral',
        name: 'Bubble Coral',
    },
    {
        id: 'minecraft:fire_coral',
        name: 'Fire Coral',
    },
    {
        id: 'minecraft:horn_coral',
        name: 'Horn Coral',
    },
    {
        id: 'minecraft:dead_brain_coral',
        name: 'Dead Brain Coral',
    },
    {
        id: 'minecraft:dead_bubble_coral',
        name: 'Dead Bubble Coral',
    },
    {
        id: 'minecraft:dead_fire_coral',
        name: 'Dead Fire Coral',
    },
    {
        id: 'minecraft:dead_horn_coral',
        name: 'Dead Horn Coral',
    },
    {
        id: 'minecraft:dead_tube_coral',
        name: 'Dead Tube Coral',
    },
    {
        id: 'minecraft:tube_coral_fan',
        name: 'Tube Coral Fan',
    },
    {
        id: 'minecraft:brain_coral_fan',
        name: 'Brain Coral Fan',
    },
    {
        id: 'minecraft:bubble_coral_fan',
        name: 'Bubble Coral Fan',
    },
    {
        id: 'minecraft:fire_coral_fan',
        name: 'Fire Coral Fan',
    },
    {
        id: 'minecraft:horn_coral_fan',
        name: 'Horn Coral Fan',
    },
    {
        id: 'minecraft:dead_tube_coral_fan',
        name: 'Dead Tube Coral Fan',
    },
    {
        id: 'minecraft:dead_brain_coral_fan',
        name: 'Dead Brain Coral Fan',
    },
    {
        id: 'minecraft:dead_bubble_coral_fan',
        name: 'Dead Bubble Coral Fan',
    },
    {
        id: 'minecraft:dead_fire_coral_fan',
        name: 'Dead Fire Coral Fan',
    },
    {
        id: 'minecraft:dead_horn_coral_fan',
        name: 'Dead Horn Coral Fan',
    },
    {
        id: 'minecraft:blue_ice',
        name: 'Blue Ice',
    },
    {
        id: 'minecraft:conduit',
        name: 'Conduit',
    },
    {
        id: 'minecraft:polished_granite_stairs',
        name: 'Polished Granite Stairs',
    },
    {
        id: 'minecraft:smooth_red_sandstone_stairs',
        name: 'Smooth Red Sandstone Stairs',
    },
    {
        id: 'minecraft:mossy_stone_brick_stairs',
        name: 'Mossy Stone Brick Stairs',
    },
    {
        id: 'minecraft:polished_diorite_stairs',
        name: 'Polished Diorite Stairs',
    },
    {
        id: 'minecraft:mossy_cobblestone_stairs',
        name: 'Mossy Cobblestone Stairs',
    },
    {
        id: 'minecraft:end_stone_brick_stairs',
        name: 'End Stone Brick Stairs',
    },
    {
        id: 'minecraft:stone_stairs',
        name: 'Stone Stairs',
    },
    {
        id: 'minecraft:smooth_sandstone_stairs',
        name: 'Smooth Sandstone Stairs',
    },
    {
        id: 'minecraft:smooth_quartz_stairs',
        name: 'Smooth Quartz Stairs',
    },
    {
        id: 'minecraft:granite_stairs',
        name: 'Granite Stairs',
    },
    {
        id: 'minecraft:andesite_stairs',
        name: 'Andesite Stairs',
    },
    {
        id: 'minecraft:red_nether_brick_stairs',
        name: 'Red Nether Brick Stairs',
    },
    {
        id: 'minecraft:polished_andesite_stairs',
        name: 'Polished Andesite Stairs',
    },
    {
        id: 'minecraft:diorite_stairs',
        name: 'Diorite Stairs',
    },
    {
        id: 'minecraft:cobbled_deepslate_stairs',
        name: 'Cobbled Deepslate Stairs',
    },
    {
        id: 'minecraft:polished_deepslate_stairs',
        name: 'Polished Deepslate Stairs',
    },
    {
        id: 'minecraft:deepslate_brick_stairs',
        name: 'Deepslate Brick Stairs',
    },
    {
        id: 'minecraft:deepslate_tile_stairs',
        name: 'Deepslate Tile Stairs',
    },
    {
        id: 'minecraft:polished_granite_slab',
        name: 'Polished Granite Slab',
    },
    {
        id: 'minecraft:smooth_red_sandstone_slab',
        name: 'Smooth Red Sandstone Slab',
    },
    {
        id: 'minecraft:mossy_stone_brick_slab',
        name: 'Mossy Stone Brick Slab',
    },
    {
        id: 'minecraft:polished_diorite_slab',
        name: 'Polished Diorite Slab',
    },
    {
        id: 'minecraft:mossy_cobblestone_slab',
        name: 'Mossy Cobblestone Slab',
    },
    {
        id: 'minecraft:end_stone_brick_slab',
        name: 'End Stone Brick Slab',
    },
    {
        id: 'minecraft:smooth_sandstone_slab',
        name: 'Smooth Sandstone Slab',
    },
    {
        id: 'minecraft:smooth_quartz_slab',
        name: 'Smooth Quartz Slab',
    },
    {
        id: 'minecraft:granite_slab',
        name: 'Granite Slab',
    },
    {
        id: 'minecraft:andesite_slab',
        name: 'Andesite Slab',
    },
    {
        id: 'minecraft:red_nether_brick_slab',
        name: 'Red Nether Brick Slab',
    },
    {
        id: 'minecraft:polished_andesite_slab',
        name: 'Polished Andesite Slab',
    },
    {
        id: 'minecraft:diorite_slab',
        name: 'Diorite Slab',
    },
    {
        id: 'minecraft:cobbled_deepslate_slab',
        name: 'Cobbled Deepslate Slab',
    },
    {
        id: 'minecraft:polished_deepslate_slab',
        name: 'Polished Deepslate Slab',
    },
    {
        id: 'minecraft:deepslate_brick_slab',
        name: 'Deepslate Brick Slab',
    },
    {
        id: 'minecraft:deepslate_tile_slab',
        name: 'Deepslate Tile Slab',
    },
    {
        id: 'minecraft:scaffolding',
        name: 'Scaffolding',
    },
    {
        id: 'minecraft:redstone',
        name: 'Redstone Dust',
    },
    {
        id: 'minecraft:redstone_torch',
        name: 'Redstone Torch',
    },
    {
        id: 'minecraft:redstone_block',
        name: 'Block of Redstone',
    },
    {
        id: 'minecraft:repeater',
        name: 'Redstone Repeater',
    },
    {
        id: 'minecraft:comparator',
        name: 'Redstone Comparator',
    },
    {
        id: 'minecraft:piston',
        name: 'Piston',
    },
    {
        id: 'minecraft:sticky_piston',
        name: 'Sticky Piston',
    },
    {
        id: 'minecraft:slime_block',
        name: 'Slime Block',
    },
    {
        id: 'minecraft:honey_block',
        name: 'Honey Block',
    },
    {
        id: 'minecraft:observer',
        name: 'Observer',
    },
    {
        id: 'minecraft:hopper',
        name: 'Hopper',
    },
    {
        id: 'minecraft:dispenser',
        name: 'Dispenser',
    },
    {
        id: 'minecraft:dropper',
        name: 'Dropper',
    },
    {
        id: 'minecraft:lectern',
        name: 'Lectern',
    },
    {
        id: 'minecraft:target',
        name: 'Target',
    },
    {
        id: 'minecraft:lever',
        name: 'Lever',
    },
    {
        id: 'minecraft:lightning_rod',
        name: 'Lightning Rod',
    },
    {
        id: 'minecraft:exposed_lightning_rod',
        name: 'Exposed Lightning Rod',
    },
    {
        id: 'minecraft:weathered_lightning_rod',
        name: 'Weathered Lightning Rod',
    },
    {
        id: 'minecraft:oxidized_lightning_rod',
        name: 'Oxidized Lightning Rod',
    },
    {
        id: 'minecraft:waxed_lightning_rod',
        name: 'Waxed Lightning Rod',
    },
    {
        id: 'minecraft:waxed_exposed_lightning_rod',
        name: 'Waxed Exposed Lightning Rod',
    },
    {
        id: 'minecraft:waxed_weathered_lightning_rod',
        name: 'Waxed Weathered Lightning Rod',
    },
    {
        id: 'minecraft:waxed_oxidized_lightning_rod',
        name: 'Waxed Oxidized Lightning Rod',
    },
    {
        id: 'minecraft:daylight_detector',
        name: 'Daylight Detector',
    },
    {
        id: 'minecraft:sculk_sensor',
        name: 'Sculk Sensor',
    },
    {
        id: 'minecraft:calibrated_sculk_sensor',
        name: 'Calibrated Sculk Sensor',
    },
    {
        id: 'minecraft:tripwire_hook',
        name: 'Tripwire Hook',
    },
    {
        id: 'minecraft:trapped_chest',
        name: 'Trapped Chest',
    },
    {
        id: 'minecraft:tnt',
        name: 'TNT',
    },
    {
        id: 'minecraft:redstone_lamp',
        name: 'Redstone Lamp',
    },
    {
        id: 'minecraft:note_block',
        name: 'Note Block',
    },
    {
        id: 'minecraft:stone_button',
        name: 'Stone Button',
    },
    {
        id: 'minecraft:polished_blackstone_button',
        name: 'Polished Blackstone Button',
    },
    {
        id: 'minecraft:oak_button',
        name: 'Oak Button',
    },
    {
        id: 'minecraft:spruce_button',
        name: 'Spruce Button',
    },
    {
        id: 'minecraft:birch_button',
        name: 'Birch Button',
    },
    {
        id: 'minecraft:jungle_button',
        name: 'Jungle Button',
    },
    {
        id: 'minecraft:acacia_button',
        name: 'Acacia Button',
    },
    {
        id: 'minecraft:cherry_button',
        name: 'Cherry Button',
    },
    {
        id: 'minecraft:dark_oak_button',
        name: 'Dark Oak Button',
    },
    {
        id: 'minecraft:pale_oak_button',
        name: 'Pale Oak Button',
    },
    {
        id: 'minecraft:mangrove_button',
        name: 'Mangrove Button',
    },
    {
        id: 'minecraft:bamboo_button',
        name: 'Bamboo Button',
    },
    {
        id: 'minecraft:crimson_button',
        name: 'Crimson Button',
    },
    {
        id: 'minecraft:warped_button',
        name: 'Warped Button',
    },
    {
        id: 'minecraft:stone_pressure_plate',
        name: 'Stone Pressure Plate',
    },
    {
        id: 'minecraft:polished_blackstone_pressure_plate',
        name: 'Polished Blackstone Pressure Plate',
    },
    {
        id: 'minecraft:light_weighted_pressure_plate',
        name: 'Light Weighted Pressure Plate',
    },
    {
        id: 'minecraft:heavy_weighted_pressure_plate',
        name: 'Heavy Weighted Pressure Plate',
    },
    {
        id: 'minecraft:oak_pressure_plate',
        name: 'Oak Pressure Plate',
    },
    {
        id: 'minecraft:spruce_pressure_plate',
        name: 'Spruce Pressure Plate',
    },
    {
        id: 'minecraft:birch_pressure_plate',
        name: 'Birch Pressure Plate',
    },
    {
        id: 'minecraft:jungle_pressure_plate',
        name: 'Jungle Pressure Plate',
    },
    {
        id: 'minecraft:acacia_pressure_plate',
        name: 'Acacia Pressure Plate',
    },
    {
        id: 'minecraft:cherry_pressure_plate',
        name: 'Cherry Pressure Plate',
    },
    {
        id: 'minecraft:dark_oak_pressure_plate',
        name: 'Dark Oak Pressure Plate',
    },
    {
        id: 'minecraft:pale_oak_pressure_plate',
        name: 'Pale Oak Pressure Plate',
    },
    {
        id: 'minecraft:mangrove_pressure_plate',
        name: 'Mangrove Pressure Plate',
    },
    {
        id: 'minecraft:bamboo_pressure_plate',
        name: 'Bamboo Pressure Plate',
    },
    {
        id: 'minecraft:crimson_pressure_plate',
        name: 'Crimson Pressure Plate',
    },
    {
        id: 'minecraft:warped_pressure_plate',
        name: 'Warped Pressure Plate',
    },
    {
        id: 'minecraft:iron_door',
        name: 'Iron Door',
    },
    {
        id: 'minecraft:oak_door',
        name: 'Oak Door',
    },
    {
        id: 'minecraft:spruce_door',
        name: 'Spruce Door',
    },
    {
        id: 'minecraft:birch_door',
        name: 'Birch Door',
    },
    {
        id: 'minecraft:jungle_door',
        name: 'Jungle Door',
    },
    {
        id: 'minecraft:acacia_door',
        name: 'Acacia Door',
    },
    {
        id: 'minecraft:cherry_door',
        name: 'Cherry Door',
    },
    {
        id: 'minecraft:dark_oak_door',
        name: 'Dark Oak Door',
    },
    {
        id: 'minecraft:pale_oak_door',
        name: 'Pale Oak Door',
    },
    {
        id: 'minecraft:mangrove_door',
        name: 'Mangrove Door',
    },
    {
        id: 'minecraft:bamboo_door',
        name: 'Bamboo Door',
    },
    {
        id: 'minecraft:crimson_door',
        name: 'Crimson Door',
    },
    {
        id: 'minecraft:warped_door',
        name: 'Warped Door',
    },
    {
        id: 'minecraft:copper_door',
        name: 'Copper Door',
    },
    {
        id: 'minecraft:exposed_copper_door',
        name: 'Exposed Copper Door',
    },
    {
        id: 'minecraft:weathered_copper_door',
        name: 'Weathered Copper Door',
    },
    {
        id: 'minecraft:oxidized_copper_door',
        name: 'Oxidized Copper Door',
    },
    {
        id: 'minecraft:waxed_copper_door',
        name: 'Waxed Copper Door',
    },
    {
        id: 'minecraft:waxed_exposed_copper_door',
        name: 'Waxed Exposed Copper Door',
    },
    {
        id: 'minecraft:waxed_weathered_copper_door',
        name: 'Waxed Weathered Copper Door',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_door',
        name: 'Waxed Oxidized Copper Door',
    },
    {
        id: 'minecraft:iron_trapdoor',
        name: 'Iron Trapdoor',
    },
    {
        id: 'minecraft:oak_trapdoor',
        name: 'Oak Trapdoor',
    },
    {
        id: 'minecraft:spruce_trapdoor',
        name: 'Spruce Trapdoor',
    },
    {
        id: 'minecraft:birch_trapdoor',
        name: 'Birch Trapdoor',
    },
    {
        id: 'minecraft:jungle_trapdoor',
        name: 'Jungle Trapdoor',
    },
    {
        id: 'minecraft:acacia_trapdoor',
        name: 'Acacia Trapdoor',
    },
    {
        id: 'minecraft:cherry_trapdoor',
        name: 'Cherry Trapdoor',
    },
    {
        id: 'minecraft:dark_oak_trapdoor',
        name: 'Dark Oak Trapdoor',
    },
    {
        id: 'minecraft:pale_oak_trapdoor',
        name: 'Pale Oak Trapdoor',
    },
    {
        id: 'minecraft:mangrove_trapdoor',
        name: 'Mangrove Trapdoor',
    },
    {
        id: 'minecraft:bamboo_trapdoor',
        name: 'Bamboo Trapdoor',
    },
    {
        id: 'minecraft:crimson_trapdoor',
        name: 'Crimson Trapdoor',
    },
    {
        id: 'minecraft:warped_trapdoor',
        name: 'Warped Trapdoor',
    },
    {
        id: 'minecraft:copper_trapdoor',
        name: 'Copper Trapdoor',
    },
    {
        id: 'minecraft:exposed_copper_trapdoor',
        name: 'Exposed Copper Trapdoor',
    },
    {
        id: 'minecraft:weathered_copper_trapdoor',
        name: 'Weathered Copper Trapdoor',
    },
    {
        id: 'minecraft:oxidized_copper_trapdoor',
        name: 'Oxidized Copper Trapdoor',
    },
    {
        id: 'minecraft:waxed_copper_trapdoor',
        name: 'Waxed Copper Trapdoor',
    },
    {
        id: 'minecraft:waxed_exposed_copper_trapdoor',
        name: 'Waxed Exposed Copper Trapdoor',
    },
    {
        id: 'minecraft:waxed_weathered_copper_trapdoor',
        name: 'Waxed Weathered Copper Trapdoor',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_trapdoor',
        name: 'Waxed Oxidized Copper Trapdoor',
    },
    {
        id: 'minecraft:oak_fence_gate',
        name: 'Oak Fence Gate',
    },
    {
        id: 'minecraft:spruce_fence_gate',
        name: 'Spruce Fence Gate',
    },
    {
        id: 'minecraft:birch_fence_gate',
        name: 'Birch Fence Gate',
    },
    {
        id: 'minecraft:jungle_fence_gate',
        name: 'Jungle Fence Gate',
    },
    {
        id: 'minecraft:acacia_fence_gate',
        name: 'Acacia Fence Gate',
    },
    {
        id: 'minecraft:cherry_fence_gate',
        name: 'Cherry Fence Gate',
    },
    {
        id: 'minecraft:dark_oak_fence_gate',
        name: 'Dark Oak Fence Gate',
    },
    {
        id: 'minecraft:pale_oak_fence_gate',
        name: 'Pale Oak Fence Gate',
    },
    {
        id: 'minecraft:mangrove_fence_gate',
        name: 'Mangrove Fence Gate',
    },
    {
        id: 'minecraft:bamboo_fence_gate',
        name: 'Bamboo Fence Gate',
    },
    {
        id: 'minecraft:crimson_fence_gate',
        name: 'Crimson Fence Gate',
    },
    {
        id: 'minecraft:warped_fence_gate',
        name: 'Warped Fence Gate',
    },
    {
        id: 'minecraft:powered_rail',
        name: 'Powered Rail',
    },
    {
        id: 'minecraft:detector_rail',
        name: 'Detector Rail',
    },
    {
        id: 'minecraft:rail',
        name: 'Rail',
    },
    {
        id: 'minecraft:activator_rail',
        name: 'Activator Rail',
    },
    {
        id: 'minecraft:saddle',
        name: 'Saddle',
    },
    {
        id: 'minecraft:white_harness',
        name: 'White Harness',
    },
    {
        id: 'minecraft:orange_harness',
        name: 'Orange Harness',
    },
    {
        id: 'minecraft:magenta_harness',
        name: 'Magenta Harness',
    },
    {
        id: 'minecraft:light_blue_harness',
        name: 'Light Blue Harness',
    },
    {
        id: 'minecraft:yellow_harness',
        name: 'Yellow Harness',
    },
    {
        id: 'minecraft:lime_harness',
        name: 'Lime Harness',
    },
    {
        id: 'minecraft:pink_harness',
        name: 'Pink Harness',
    },
    {
        id: 'minecraft:gray_harness',
        name: 'Gray Harness',
    },
    {
        id: 'minecraft:light_gray_harness',
        name: 'Light Gray Harness',
    },
    {
        id: 'minecraft:cyan_harness',
        name: 'Cyan Harness',
    },
    {
        id: 'minecraft:purple_harness',
        name: 'Purple Harness',
    },
    {
        id: 'minecraft:blue_harness',
        name: 'Blue Harness',
    },
    {
        id: 'minecraft:brown_harness',
        name: 'Brown Harness',
    },
    {
        id: 'minecraft:green_harness',
        name: 'Green Harness',
    },
    {
        id: 'minecraft:red_harness',
        name: 'Red Harness',
    },
    {
        id: 'minecraft:black_harness',
        name: 'Black Harness',
    },
    {
        id: 'minecraft:minecart',
        name: 'Minecart',
    },
    {
        id: 'minecraft:chest_minecart',
        name: 'Minecart with Chest',
    },
    {
        id: 'minecraft:furnace_minecart',
        name: 'Minecart with Furnace',
    },
    {
        id: 'minecraft:tnt_minecart',
        name: 'Minecart with TNT',
    },
    {
        id: 'minecraft:hopper_minecart',
        name: 'Minecart with Hopper',
    },
    {
        id: 'minecraft:carrot_on_a_stick',
        name: 'Carrot on a Stick',
    },
    {
        id: 'minecraft:warped_fungus_on_a_stick',
        name: 'Warped Fungus on a Stick',
    },
    {
        id: 'minecraft:phantom_membrane',
        name: 'Phantom Membrane',
    },
    {
        id: 'minecraft:elytra',
        name: 'Elytra',
    },
    {
        id: 'minecraft:oak_boat',
        name: 'Oak Boat',
    },
    {
        id: 'minecraft:oak_chest_boat',
        name: 'Oak Boat with Chest',
    },
    {
        id: 'minecraft:spruce_boat',
        name: 'Spruce Boat',
    },
    {
        id: 'minecraft:spruce_chest_boat',
        name: 'Spruce Boat with Chest',
    },
    {
        id: 'minecraft:birch_boat',
        name: 'Birch Boat',
    },
    {
        id: 'minecraft:birch_chest_boat',
        name: 'Birch Boat with Chest',
    },
    {
        id: 'minecraft:jungle_boat',
        name: 'Jungle Boat',
    },
    {
        id: 'minecraft:jungle_chest_boat',
        name: 'Jungle Boat with Chest',
    },
    {
        id: 'minecraft:acacia_boat',
        name: 'Acacia Boat',
    },
    {
        id: 'minecraft:acacia_chest_boat',
        name: 'Acacia Boat with Chest',
    },
    {
        id: 'minecraft:cherry_boat',
        name: 'Cherry Boat',
    },
    {
        id: 'minecraft:cherry_chest_boat',
        name: 'Cherry Boat with Chest',
    },
    {
        id: 'minecraft:dark_oak_boat',
        name: 'Dark Oak Boat',
    },
    {
        id: 'minecraft:dark_oak_chest_boat',
        name: 'Dark Oak Boat with Chest',
    },
    {
        id: 'minecraft:pale_oak_boat',
        name: 'Pale Oak Boat',
    },
    {
        id: 'minecraft:pale_oak_chest_boat',
        name: 'Pale Oak Boat with Chest',
    },
    {
        id: 'minecraft:mangrove_boat',
        name: 'Mangrove Boat',
    },
    {
        id: 'minecraft:mangrove_chest_boat',
        name: 'Mangrove Boat with Chest',
    },
    {
        id: 'minecraft:bamboo_raft',
        name: 'Bamboo Raft',
    },
    {
        id: 'minecraft:bamboo_chest_raft',
        name: 'Bamboo Raft with Chest',
    },
    {
        id: 'minecraft:structure_block',
        name: 'Structure Block',
    },
    {
        id: 'minecraft:jigsaw',
        name: 'Jigsaw Block',
    },
    {
        id: 'minecraft:test_block',
        name: 'Test Block',
    },
    {
        id: 'minecraft:test_instance_block',
        name: 'Test Instance Block',
    },
    {
        id: 'minecraft:turtle_helmet',
        name: 'Turtle Shell',
    },
    {
        id: 'minecraft:turtle_scute',
        name: 'Turtle Scute',
    },
    {
        id: 'minecraft:armadillo_scute',
        name: 'Armadillo Scute',
    },
    {
        id: 'minecraft:wolf_armor',
        name: 'Wolf Armor',
    },
    {
        id: 'minecraft:flint_and_steel',
        name: 'Flint and Steel',
    },
    {
        id: 'minecraft:bowl',
        name: 'Bowl',
    },
    {
        id: 'minecraft:apple',
        name: 'Apple',
    },
    {
        id: 'minecraft:bow',
        name: 'Bow',
    },
    {
        id: 'minecraft:arrow',
        name: 'Arrow',
    },
    {
        id: 'minecraft:coal',
        name: 'Coal',
    },
    {
        id: 'minecraft:charcoal',
        name: 'Charcoal',
    },
    {
        id: 'minecraft:diamond',
        name: 'Diamond',
    },
    {
        id: 'minecraft:emerald',
        name: 'Emerald',
    },
    {
        id: 'minecraft:lapis_lazuli',
        name: 'Lapis Lazuli',
    },
    {
        id: 'minecraft:quartz',
        name: 'Nether Quartz',
    },
    {
        id: 'minecraft:amethyst_shard',
        name: 'Amethyst Shard',
    },
    {
        id: 'minecraft:raw_iron',
        name: 'Raw Iron',
    },
    {
        id: 'minecraft:iron_ingot',
        name: 'Iron Ingot',
    },
    {
        id: 'minecraft:raw_copper',
        name: 'Raw Copper',
    },
    {
        id: 'minecraft:copper_ingot',
        name: 'Copper Ingot',
    },
    {
        id: 'minecraft:raw_gold',
        name: 'Raw Gold',
    },
    {
        id: 'minecraft:gold_ingot',
        name: 'Gold Ingot',
    },
    {
        id: 'minecraft:netherite_ingot',
        name: 'Netherite Ingot',
    },
    {
        id: 'minecraft:netherite_scrap',
        name: 'Netherite Scrap',
    },
    {
        id: 'minecraft:wooden_sword',
        name: 'Wooden Sword',
    },
    {
        id: 'minecraft:wooden_shovel',
        name: 'Wooden Shovel',
    },
    {
        id: 'minecraft:wooden_pickaxe',
        name: 'Wooden Pickaxe',
    },
    {
        id: 'minecraft:wooden_axe',
        name: 'Wooden Axe',
    },
    {
        id: 'minecraft:wooden_hoe',
        name: 'Wooden Hoe',
    },
    {
        id: 'minecraft:copper_sword',
        name: 'Copper Sword',
    },
    {
        id: 'minecraft:copper_shovel',
        name: 'Copper Shovel',
    },
    {
        id: 'minecraft:copper_pickaxe',
        name: 'Copper Pickaxe',
    },
    {
        id: 'minecraft:copper_axe',
        name: 'Copper Axe',
    },
    {
        id: 'minecraft:copper_hoe',
        name: 'Copper Hoe',
    },
    {
        id: 'minecraft:stone_sword',
        name: 'Stone Sword',
    },
    {
        id: 'minecraft:stone_shovel',
        name: 'Stone Shovel',
    },
    {
        id: 'minecraft:stone_pickaxe',
        name: 'Stone Pickaxe',
    },
    {
        id: 'minecraft:stone_axe',
        name: 'Stone Axe',
    },
    {
        id: 'minecraft:stone_hoe',
        name: 'Stone Hoe',
    },
    {
        id: 'minecraft:golden_sword',
        name: 'Golden Sword',
    },
    {
        id: 'minecraft:golden_shovel',
        name: 'Golden Shovel',
    },
    {
        id: 'minecraft:golden_pickaxe',
        name: 'Golden Pickaxe',
    },
    {
        id: 'minecraft:golden_axe',
        name: 'Golden Axe',
    },
    {
        id: 'minecraft:golden_hoe',
        name: 'Golden Hoe',
    },
    {
        id: 'minecraft:iron_sword',
        name: 'Iron Sword',
    },
    {
        id: 'minecraft:iron_shovel',
        name: 'Iron Shovel',
    },
    {
        id: 'minecraft:iron_pickaxe',
        name: 'Iron Pickaxe',
    },
    {
        id: 'minecraft:iron_axe',
        name: 'Iron Axe',
    },
    {
        id: 'minecraft:iron_hoe',
        name: 'Iron Hoe',
    },
    {
        id: 'minecraft:diamond_sword',
        name: 'Diamond Sword',
    },
    {
        id: 'minecraft:diamond_shovel',
        name: 'Diamond Shovel',
    },
    {
        id: 'minecraft:diamond_pickaxe',
        name: 'Diamond Pickaxe',
    },
    {
        id: 'minecraft:diamond_axe',
        name: 'Diamond Axe',
    },
    {
        id: 'minecraft:diamond_hoe',
        name: 'Diamond Hoe',
    },
    {
        id: 'minecraft:netherite_sword',
        name: 'Netherite Sword',
    },
    {
        id: 'minecraft:netherite_shovel',
        name: 'Netherite Shovel',
    },
    {
        id: 'minecraft:netherite_pickaxe',
        name: 'Netherite Pickaxe',
    },
    {
        id: 'minecraft:netherite_axe',
        name: 'Netherite Axe',
    },
    {
        id: 'minecraft:netherite_hoe',
        name: 'Netherite Hoe',
    },
    {
        id: 'minecraft:stick',
        name: 'Stick',
    },
    {
        id: 'minecraft:mushroom_stew',
        name: 'Mushroom Stew',
    },
    {
        id: 'minecraft:string',
        name: 'String',
    },
    {
        id: 'minecraft:feather',
        name: 'Feather',
    },
    {
        id: 'minecraft:gunpowder',
        name: 'Gunpowder',
    },
    {
        id: 'minecraft:wheat_seeds',
        name: 'Wheat Seeds',
    },
    {
        id: 'minecraft:wheat',
        name: 'Wheat',
    },
    {
        id: 'minecraft:bread',
        name: 'Bread',
    },
    {
        id: 'minecraft:leather_helmet',
        name: 'Leather Cap',
    },
    {
        id: 'minecraft:leather_chestplate',
        name: 'Leather Tunic',
    },
    {
        id: 'minecraft:leather_leggings',
        name: 'Leather Pants',
    },
    {
        id: 'minecraft:leather_boots',
        name: 'Leather Boots',
    },
    {
        id: 'minecraft:copper_helmet',
        name: 'Copper Helmet',
    },
    {
        id: 'minecraft:copper_chestplate',
        name: 'Copper Chestplate',
    },
    {
        id: 'minecraft:copper_leggings',
        name: 'Copper Leggings',
    },
    {
        id: 'minecraft:copper_boots',
        name: 'Copper Boots',
    },
    {
        id: 'minecraft:chainmail_helmet',
        name: 'Chainmail Helmet',
    },
    {
        id: 'minecraft:chainmail_chestplate',
        name: 'Chainmail Chestplate',
    },
    {
        id: 'minecraft:chainmail_leggings',
        name: 'Chainmail Leggings',
    },
    {
        id: 'minecraft:chainmail_boots',
        name: 'Chainmail Boots',
    },
    {
        id: 'minecraft:iron_helmet',
        name: 'Iron Helmet',
    },
    {
        id: 'minecraft:iron_chestplate',
        name: 'Iron Chestplate',
    },
    {
        id: 'minecraft:iron_leggings',
        name: 'Iron Leggings',
    },
    {
        id: 'minecraft:iron_boots',
        name: 'Iron Boots',
    },
    {
        id: 'minecraft:diamond_helmet',
        name: 'Diamond Helmet',
    },
    {
        id: 'minecraft:diamond_chestplate',
        name: 'Diamond Chestplate',
    },
    {
        id: 'minecraft:diamond_leggings',
        name: 'Diamond Leggings',
    },
    {
        id: 'minecraft:diamond_boots',
        name: 'Diamond Boots',
    },
    {
        id: 'minecraft:golden_helmet',
        name: 'Golden Helmet',
    },
    {
        id: 'minecraft:golden_chestplate',
        name: 'Golden Chestplate',
    },
    {
        id: 'minecraft:golden_leggings',
        name: 'Golden Leggings',
    },
    {
        id: 'minecraft:golden_boots',
        name: 'Golden Boots',
    },
    {
        id: 'minecraft:netherite_helmet',
        name: 'Netherite Helmet',
    },
    {
        id: 'minecraft:netherite_chestplate',
        name: 'Netherite Chestplate',
    },
    {
        id: 'minecraft:netherite_leggings',
        name: 'Netherite Leggings',
    },
    {
        id: 'minecraft:netherite_boots',
        name: 'Netherite Boots',
    },
    {
        id: 'minecraft:flint',
        name: 'Flint',
    },
    {
        id: 'minecraft:porkchop',
        name: 'Raw Porkchop',
    },
    {
        id: 'minecraft:cooked_porkchop',
        name: 'Cooked Porkchop',
    },
    {
        id: 'minecraft:painting',
        name: 'Painting',
    },
    {
        id: 'minecraft:golden_apple',
        name: 'Golden Apple',
    },
    {
        id: 'minecraft:enchanted_golden_apple',
        name: 'Enchanted Golden Apple',
    },
    {
        id: 'minecraft:oak_sign',
        name: 'Oak Sign',
    },
    {
        id: 'minecraft:spruce_sign',
        name: 'Spruce Sign',
    },
    {
        id: 'minecraft:birch_sign',
        name: 'Birch Sign',
    },
    {
        id: 'minecraft:jungle_sign',
        name: 'Jungle Sign',
    },
    {
        id: 'minecraft:acacia_sign',
        name: 'Acacia Sign',
    },
    {
        id: 'minecraft:cherry_sign',
        name: 'Cherry Sign',
    },
    {
        id: 'minecraft:dark_oak_sign',
        name: 'Dark Oak Sign',
    },
    {
        id: 'minecraft:pale_oak_sign',
        name: 'Pale Oak Sign',
    },
    {
        id: 'minecraft:mangrove_sign',
        name: 'Mangrove Sign',
    },
    {
        id: 'minecraft:bamboo_sign',
        name: 'Bamboo Sign',
    },
    {
        id: 'minecraft:crimson_sign',
        name: 'Crimson Sign',
    },
    {
        id: 'minecraft:warped_sign',
        name: 'Warped Sign',
    },
    {
        id: 'minecraft:oak_hanging_sign',
        name: 'Oak Hanging Sign',
    },
    {
        id: 'minecraft:spruce_hanging_sign',
        name: 'Spruce Hanging Sign',
    },
    {
        id: 'minecraft:birch_hanging_sign',
        name: 'Birch Hanging Sign',
    },
    {
        id: 'minecraft:jungle_hanging_sign',
        name: 'Jungle Hanging Sign',
    },
    {
        id: 'minecraft:acacia_hanging_sign',
        name: 'Acacia Hanging Sign',
    },
    {
        id: 'minecraft:cherry_hanging_sign',
        name: 'Cherry Hanging Sign',
    },
    {
        id: 'minecraft:dark_oak_hanging_sign',
        name: 'Dark Oak Hanging Sign',
    },
    {
        id: 'minecraft:pale_oak_hanging_sign',
        name: 'Pale Oak Hanging Sign',
    },
    {
        id: 'minecraft:mangrove_hanging_sign',
        name: 'Mangrove Hanging Sign',
    },
    {
        id: 'minecraft:bamboo_hanging_sign',
        name: 'Bamboo Hanging Sign',
    },
    {
        id: 'minecraft:crimson_hanging_sign',
        name: 'Crimson Hanging Sign',
    },
    {
        id: 'minecraft:warped_hanging_sign',
        name: 'Warped Hanging Sign',
    },
    {
        id: 'minecraft:bucket',
        name: 'Bucket',
    },
    {
        id: 'minecraft:water_bucket',
        name: 'Water Bucket',
    },
    {
        id: 'minecraft:lava_bucket',
        name: 'Lava Bucket',
    },
    {
        id: 'minecraft:powder_snow_bucket',
        name: 'Powder Snow Bucket',
    },
    {
        id: 'minecraft:snowball',
        name: 'Snowball',
    },
    {
        id: 'minecraft:leather',
        name: 'Leather',
    },
    {
        id: 'minecraft:milk_bucket',
        name: 'Milk Bucket',
    },
    {
        id: 'minecraft:pufferfish_bucket',
        name: 'Bucket of Pufferfish',
    },
    {
        id: 'minecraft:salmon_bucket',
        name: 'Bucket of Salmon',
    },
    {
        id: 'minecraft:cod_bucket',
        name: 'Bucket of Cod',
    },
    {
        id: 'minecraft:tropical_fish_bucket',
        name: 'Bucket of Tropical Fish',
    },
    {
        id: 'minecraft:axolotl_bucket',
        name: 'Bucket of Axolotl',
    },
    {
        id: 'minecraft:tadpole_bucket',
        name: 'Bucket of Tadpole',
    },
    {
        id: 'minecraft:brick',
        name: 'Brick',
    },
    {
        id: 'minecraft:clay_ball',
        name: 'Clay Ball',
    },
    {
        id: 'minecraft:dried_kelp_block',
        name: 'Dried Kelp Block',
    },
    {
        id: 'minecraft:paper',
        name: 'Paper',
    },
    {
        id: 'minecraft:book',
        name: 'Book',
    },
    {
        id: 'minecraft:slime_ball',
        name: 'Slimeball',
    },
    {
        id: 'minecraft:egg',
        name: 'Egg',
    },
    {
        id: 'minecraft:blue_egg',
        name: 'Blue Egg',
    },
    {
        id: 'minecraft:brown_egg',
        name: 'Brown Egg',
    },
    {
        id: 'minecraft:compass',
        name: 'Compass',
    },
    {
        id: 'minecraft:recovery_compass',
        name: 'Recovery Compass',
    },
    {
        id: 'minecraft:bundle',
        name: 'Bundle',
    },
    {
        id: 'minecraft:white_bundle',
        name: 'White Bundle',
    },
    {
        id: 'minecraft:orange_bundle',
        name: 'Orange Bundle',
    },
    {
        id: 'minecraft:magenta_bundle',
        name: 'Magenta Bundle',
    },
    {
        id: 'minecraft:light_blue_bundle',
        name: 'Light Blue Bundle',
    },
    {
        id: 'minecraft:yellow_bundle',
        name: 'Yellow Bundle',
    },
    {
        id: 'minecraft:lime_bundle',
        name: 'Lime Bundle',
    },
    {
        id: 'minecraft:pink_bundle',
        name: 'Pink Bundle',
    },
    {
        id: 'minecraft:gray_bundle',
        name: 'Gray Bundle',
    },
    {
        id: 'minecraft:light_gray_bundle',
        name: 'Light Gray Bundle',
    },
    {
        id: 'minecraft:cyan_bundle',
        name: 'Cyan Bundle',
    },
    {
        id: 'minecraft:purple_bundle',
        name: 'Purple Bundle',
    },
    {
        id: 'minecraft:blue_bundle',
        name: 'Blue Bundle',
    },
    {
        id: 'minecraft:brown_bundle',
        name: 'Brown Bundle',
    },
    {
        id: 'minecraft:green_bundle',
        name: 'Green Bundle',
    },
    {
        id: 'minecraft:red_bundle',
        name: 'Red Bundle',
    },
    {
        id: 'minecraft:black_bundle',
        name: 'Black Bundle',
    },
    {
        id: 'minecraft:fishing_rod',
        name: 'Fishing Rod',
    },
    {
        id: 'minecraft:clock',
        name: 'Clock',
    },
    {
        id: 'minecraft:spyglass',
        name: 'Spyglass',
    },
    {
        id: 'minecraft:glowstone_dust',
        name: 'Glowstone Dust',
    },
    {
        id: 'minecraft:cod',
        name: 'Raw Cod',
    },
    {
        id: 'minecraft:salmon',
        name: 'Raw Salmon',
    },
    {
        id: 'minecraft:tropical_fish',
        name: 'Tropical Fish',
    },
    {
        id: 'minecraft:pufferfish',
        name: 'Pufferfish',
    },
    {
        id: 'minecraft:cooked_cod',
        name: 'Cooked Cod',
    },
    {
        id: 'minecraft:cooked_salmon',
        name: 'Cooked Salmon',
    },
    {
        id: 'minecraft:ink_sac',
        name: 'Ink Sac',
    },
    {
        id: 'minecraft:glow_ink_sac',
        name: 'Glow Ink Sac',
    },
    {
        id: 'minecraft:cocoa_beans',
        name: 'Cocoa Beans',
    },
    {
        id: 'minecraft:white_dye',
        name: 'White Dye',
    },
    {
        id: 'minecraft:orange_dye',
        name: 'Orange Dye',
    },
    {
        id: 'minecraft:magenta_dye',
        name: 'Magenta Dye',
    },
    {
        id: 'minecraft:light_blue_dye',
        name: 'Light Blue Dye',
    },
    {
        id: 'minecraft:yellow_dye',
        name: 'Yellow Dye',
    },
    {
        id: 'minecraft:lime_dye',
        name: 'Lime Dye',
    },
    {
        id: 'minecraft:pink_dye',
        name: 'Pink Dye',
    },
    {
        id: 'minecraft:gray_dye',
        name: 'Gray Dye',
    },
    {
        id: 'minecraft:light_gray_dye',
        name: 'Light Gray Dye',
    },
    {
        id: 'minecraft:cyan_dye',
        name: 'Cyan Dye',
    },
    {
        id: 'minecraft:purple_dye',
        name: 'Purple Dye',
    },
    {
        id: 'minecraft:blue_dye',
        name: 'Blue Dye',
    },
    {
        id: 'minecraft:brown_dye',
        name: 'Brown Dye',
    },
    {
        id: 'minecraft:green_dye',
        name: 'Green Dye',
    },
    {
        id: 'minecraft:red_dye',
        name: 'Red Dye',
    },
    {
        id: 'minecraft:black_dye',
        name: 'Black Dye',
    },
    {
        id: 'minecraft:bone_meal',
        name: 'Bone Meal',
    },
    {
        id: 'minecraft:bone',
        name: 'Bone',
    },
    {
        id: 'minecraft:sugar',
        name: 'Sugar',
    },
    {
        id: 'minecraft:cake',
        name: 'Cake',
    },
    {
        id: 'minecraft:white_bed',
        name: 'White Bed',
    },
    {
        id: 'minecraft:orange_bed',
        name: 'Orange Bed',
    },
    {
        id: 'minecraft:magenta_bed',
        name: 'Magenta Bed',
    },
    {
        id: 'minecraft:light_blue_bed',
        name: 'Light Blue Bed',
    },
    {
        id: 'minecraft:yellow_bed',
        name: 'Yellow Bed',
    },
    {
        id: 'minecraft:lime_bed',
        name: 'Lime Bed',
    },
    {
        id: 'minecraft:pink_bed',
        name: 'Pink Bed',
    },
    {
        id: 'minecraft:gray_bed',
        name: 'Gray Bed',
    },
    {
        id: 'minecraft:light_gray_bed',
        name: 'Light Gray Bed',
    },
    {
        id: 'minecraft:cyan_bed',
        name: 'Cyan Bed',
    },
    {
        id: 'minecraft:purple_bed',
        name: 'Purple Bed',
    },
    {
        id: 'minecraft:blue_bed',
        name: 'Blue Bed',
    },
    {
        id: 'minecraft:brown_bed',
        name: 'Brown Bed',
    },
    {
        id: 'minecraft:green_bed',
        name: 'Green Bed',
    },
    {
        id: 'minecraft:red_bed',
        name: 'Red Bed',
    },
    {
        id: 'minecraft:black_bed',
        name: 'Black Bed',
    },
    {
        id: 'minecraft:cookie',
        name: 'Cookie',
    },
    {
        id: 'minecraft:crafter',
        name: 'Crafter',
    },
    {
        id: 'minecraft:filled_map',
        name: 'Map',
    },
    {
        id: 'minecraft:shears',
        name: 'Shears',
    },
    {
        id: 'minecraft:melon_slice',
        name: 'Melon Slice',
    },
    {
        id: 'minecraft:dried_kelp',
        name: 'Dried Kelp',
    },
    {
        id: 'minecraft:pumpkin_seeds',
        name: 'Pumpkin Seeds',
    },
    {
        id: 'minecraft:melon_seeds',
        name: 'Melon Seeds',
    },
    {
        id: 'minecraft:beef',
        name: 'Raw Beef',
    },
    {
        id: 'minecraft:cooked_beef',
        name: 'Steak',
    },
    {
        id: 'minecraft:chicken',
        name: 'Raw Chicken',
    },
    {
        id: 'minecraft:cooked_chicken',
        name: 'Cooked Chicken',
    },
    {
        id: 'minecraft:rotten_flesh',
        name: 'Rotten Flesh',
    },
    {
        id: 'minecraft:ender_pearl',
        name: 'Ender Pearl',
    },
    {
        id: 'minecraft:blaze_rod',
        name: 'Blaze Rod',
    },
    {
        id: 'minecraft:ghast_tear',
        name: 'Ghast Tear',
    },
    {
        id: 'minecraft:gold_nugget',
        name: 'Gold Nugget',
    },
    {
        id: 'minecraft:nether_wart',
        name: 'Nether Wart',
    },
    {
        id: 'minecraft:glass_bottle',
        name: 'Glass Bottle',
    },
    {
        id: 'minecraft:potion',
        name: 'Potion',
    },
    {
        id: 'minecraft:spider_eye',
        name: 'Spider Eye',
    },
    {
        id: 'minecraft:fermented_spider_eye',
        name: 'Fermented Spider Eye',
    },
    {
        id: 'minecraft:blaze_powder',
        name: 'Blaze Powder',
    },
    {
        id: 'minecraft:magma_cream',
        name: 'Magma Cream',
    },
    {
        id: 'minecraft:brewing_stand',
        name: 'Brewing Stand',
    },
    {
        id: 'minecraft:cauldron',
        name: 'Cauldron',
    },
    {
        id: 'minecraft:ender_eye',
        name: 'Eye of Ender',
    },
    {
        id: 'minecraft:glistering_melon_slice',
        name: 'Glistering Melon Slice',
    },
    {
        id: 'minecraft:chicken_spawn_egg',
        name: 'Chicken Spawn Egg',
    },
    {
        id: 'minecraft:cow_spawn_egg',
        name: 'Cow Spawn Egg',
    },
    {
        id: 'minecraft:pig_spawn_egg',
        name: 'Pig Spawn Egg',
    },
    {
        id: 'minecraft:sheep_spawn_egg',
        name: 'Sheep Spawn Egg',
    },
    {
        id: 'minecraft:camel_spawn_egg',
        name: 'Camel Spawn Egg',
    },
    {
        id: 'minecraft:donkey_spawn_egg',
        name: 'Donkey Spawn Egg',
    },
    {
        id: 'minecraft:horse_spawn_egg',
        name: 'Horse Spawn Egg',
    },
    {
        id: 'minecraft:mule_spawn_egg',
        name: 'Mule Spawn Egg',
    },
    {
        id: 'minecraft:cat_spawn_egg',
        name: 'Cat Spawn Egg',
    },
    {
        id: 'minecraft:parrot_spawn_egg',
        name: 'Parrot Spawn Egg',
    },
    {
        id: 'minecraft:wolf_spawn_egg',
        name: 'Wolf Spawn Egg',
    },
    {
        id: 'minecraft:armadillo_spawn_egg',
        name: 'Armadillo Spawn Egg',
    },
    {
        id: 'minecraft:bat_spawn_egg',
        name: 'Bat Spawn Egg',
    },
    {
        id: 'minecraft:bee_spawn_egg',
        name: 'Bee Spawn Egg',
    },
    {
        id: 'minecraft:fox_spawn_egg',
        name: 'Fox Spawn Egg',
    },
    {
        id: 'minecraft:goat_spawn_egg',
        name: 'Goat Spawn Egg',
    },
    {
        id: 'minecraft:llama_spawn_egg',
        name: 'Llama Spawn Egg',
    },
    {
        id: 'minecraft:ocelot_spawn_egg',
        name: 'Ocelot Spawn Egg',
    },
    {
        id: 'minecraft:panda_spawn_egg',
        name: 'Panda Spawn Egg',
    },
    {
        id: 'minecraft:polar_bear_spawn_egg',
        name: 'Polar Bear Spawn Egg',
    },
    {
        id: 'minecraft:rabbit_spawn_egg',
        name: 'Rabbit Spawn Egg',
    },
    {
        id: 'minecraft:axolotl_spawn_egg',
        name: 'Axolotl Spawn Egg',
    },
    {
        id: 'minecraft:cod_spawn_egg',
        name: 'Cod Spawn Egg',
    },
    {
        id: 'minecraft:dolphin_spawn_egg',
        name: 'Dolphin Spawn Egg',
    },
    {
        id: 'minecraft:frog_spawn_egg',
        name: 'Frog Spawn Egg',
    },
    {
        id: 'minecraft:glow_squid_spawn_egg',
        name: 'Glow Squid Spawn Egg',
    },
    {
        id: 'minecraft:nautilus_spawn_egg',
        name: 'Nautilus Spawn Egg',
    },
    {
        id: 'minecraft:pufferfish_spawn_egg',
        name: 'Pufferfish Spawn Egg',
    },
    {
        id: 'minecraft:salmon_spawn_egg',
        name: 'Salmon Spawn Egg',
    },
    {
        id: 'minecraft:squid_spawn_egg',
        name: 'Squid Spawn Egg',
    },
    {
        id: 'minecraft:tadpole_spawn_egg',
        name: 'Tadpole Spawn Egg',
    },
    {
        id: 'minecraft:tropical_fish_spawn_egg',
        name: 'Tropical Fish Spawn Egg',
    },
    {
        id: 'minecraft:turtle_spawn_egg',
        name: 'Turtle Spawn Egg',
    },
    {
        id: 'minecraft:allay_spawn_egg',
        name: 'Allay Spawn Egg',
    },
    {
        id: 'minecraft:mooshroom_spawn_egg',
        name: 'Mooshroom Spawn Egg',
    },
    {
        id: 'minecraft:sniffer_spawn_egg',
        name: 'Sniffer Spawn Egg',
    },
    {
        id: 'minecraft:copper_golem_spawn_egg',
        name: 'Copper Golem Spawn Egg',
    },
    {
        id: 'minecraft:iron_golem_spawn_egg',
        name: 'Iron Golem Spawn Egg',
    },
    {
        id: 'minecraft:snow_golem_spawn_egg',
        name: 'Snow Golem Spawn Egg',
    },
    {
        id: 'minecraft:trader_llama_spawn_egg',
        name: 'Trader Llama Spawn Egg',
    },
    {
        id: 'minecraft:villager_spawn_egg',
        name: 'Villager Spawn Egg',
    },
    {
        id: 'minecraft:wandering_trader_spawn_egg',
        name: 'Wandering Trader Spawn Egg',
    },
    {
        id: 'minecraft:bogged_spawn_egg',
        name: 'Bogged Spawn Egg',
    },
    {
        id: 'minecraft:camel_husk_spawn_egg',
        name: 'Camel Husk Spawn Egg',
    },
    {
        id: 'minecraft:drowned_spawn_egg',
        name: 'Drowned Spawn Egg',
    },
    {
        id: 'minecraft:husk_spawn_egg',
        name: 'Husk Spawn Egg',
    },
    {
        id: 'minecraft:parched_spawn_egg',
        name: 'Parched Spawn Egg',
    },
    {
        id: 'minecraft:skeleton_spawn_egg',
        name: 'Skeleton Spawn Egg',
    },
    {
        id: 'minecraft:skeleton_horse_spawn_egg',
        name: 'Skeleton Horse Spawn Egg',
    },
    {
        id: 'minecraft:stray_spawn_egg',
        name: 'Stray Spawn Egg',
    },
    {
        id: 'minecraft:wither_spawn_egg',
        name: 'Wither Spawn Egg',
    },
    {
        id: 'minecraft:wither_skeleton_spawn_egg',
        name: 'Wither Skeleton Spawn Egg',
    },
    {
        id: 'minecraft:zombie_spawn_egg',
        name: 'Zombie Spawn Egg',
    },
    {
        id: 'minecraft:zombie_horse_spawn_egg',
        name: 'Zombie Horse Spawn Egg',
    },
    {
        id: 'minecraft:zombie_nautilus_spawn_egg',
        name: 'Zombie Nautilus Spawn Egg',
    },
    {
        id: 'minecraft:zombie_villager_spawn_egg',
        name: 'Zombie Villager Spawn Egg',
    },
    {
        id: 'minecraft:cave_spider_spawn_egg',
        name: 'Cave Spider Spawn Egg',
    },
    {
        id: 'minecraft:spider_spawn_egg',
        name: 'Spider Spawn Egg',
    },
    {
        id: 'minecraft:breeze_spawn_egg',
        name: 'Breeze Spawn Egg',
    },
    {
        id: 'minecraft:creaking_spawn_egg',
        name: 'Creaking Spawn Egg',
    },
    {
        id: 'minecraft:creeper_spawn_egg',
        name: 'Creeper Spawn Egg',
    },
    {
        id: 'minecraft:elder_guardian_spawn_egg',
        name: 'Elder Guardian Spawn Egg',
    },
    {
        id: 'minecraft:guardian_spawn_egg',
        name: 'Guardian Spawn Egg',
    },
    {
        id: 'minecraft:phantom_spawn_egg',
        name: 'Phantom Spawn Egg',
    },
    {
        id: 'minecraft:silverfish_spawn_egg',
        name: 'Silverfish Spawn Egg',
    },
    {
        id: 'minecraft:slime_spawn_egg',
        name: 'Slime Spawn Egg',
    },
    {
        id: 'minecraft:warden_spawn_egg',
        name: 'Warden Spawn Egg',
    },
    {
        id: 'minecraft:witch_spawn_egg',
        name: 'Witch Spawn Egg',
    },
    {
        id: 'minecraft:evoker_spawn_egg',
        name: 'Evoker Spawn Egg',
    },
    {
        id: 'minecraft:pillager_spawn_egg',
        name: 'Pillager Spawn Egg',
    },
    {
        id: 'minecraft:ravager_spawn_egg',
        name: 'Ravager Spawn Egg',
    },
    {
        id: 'minecraft:vindicator_spawn_egg',
        name: 'Vindicator Spawn Egg',
    },
    {
        id: 'minecraft:vex_spawn_egg',
        name: 'Vex Spawn Egg',
    },
    {
        id: 'minecraft:blaze_spawn_egg',
        name: 'Blaze Spawn Egg',
    },
    {
        id: 'minecraft:ghast_spawn_egg',
        name: 'Ghast Spawn Egg',
    },
    {
        id: 'minecraft:happy_ghast_spawn_egg',
        name: 'Happy Ghast Spawn Egg',
    },
    {
        id: 'minecraft:hoglin_spawn_egg',
        name: 'Hoglin Spawn Egg',
    },
    {
        id: 'minecraft:magma_cube_spawn_egg',
        name: 'Magma Cube Spawn Egg',
    },
    {
        id: 'minecraft:piglin_spawn_egg',
        name: 'Piglin Spawn Egg',
    },
    {
        id: 'minecraft:piglin_brute_spawn_egg',
        name: 'Piglin Brute Spawn Egg',
    },
    {
        id: 'minecraft:strider_spawn_egg',
        name: 'Strider Spawn Egg',
    },
    {
        id: 'minecraft:zoglin_spawn_egg',
        name: 'Zoglin Spawn Egg',
    },
    {
        id: 'minecraft:zombified_piglin_spawn_egg',
        name: 'Zombified Piglin Spawn Egg',
    },
    {
        id: 'minecraft:ender_dragon_spawn_egg',
        name: 'Ender Dragon Spawn Egg',
    },
    {
        id: 'minecraft:enderman_spawn_egg',
        name: 'Enderman Spawn Egg',
    },
    {
        id: 'minecraft:endermite_spawn_egg',
        name: 'Endermite Spawn Egg',
    },
    {
        id: 'minecraft:shulker_spawn_egg',
        name: 'Shulker Spawn Egg',
    },
    {
        id: 'minecraft:experience_bottle',
        name: "Bottle o' Enchanting",
    },
    {
        id: 'minecraft:fire_charge',
        name: 'Fire Charge',
    },
    {
        id: 'minecraft:wind_charge',
        name: 'Wind Charge',
    },
    {
        id: 'minecraft:writable_book',
        name: 'Book and Quill',
    },
    {
        id: 'minecraft:written_book',
        name: 'Written Book',
    },
    {
        id: 'minecraft:breeze_rod',
        name: 'Breeze Rod',
    },
    {
        id: 'minecraft:mace',
        name: 'Mace',
    },
    {
        id: 'minecraft:item_frame',
        name: 'Item Frame',
    },
    {
        id: 'minecraft:glow_item_frame',
        name: 'Glow Item Frame',
    },
    {
        id: 'minecraft:flower_pot',
        name: 'Flower Pot',
    },
    {
        id: 'minecraft:carrot',
        name: 'Carrot',
    },
    {
        id: 'minecraft:potato',
        name: 'Potato',
    },
    {
        id: 'minecraft:baked_potato',
        name: 'Baked Potato',
    },
    {
        id: 'minecraft:poisonous_potato',
        name: 'Poisonous Potato',
    },
    {
        id: 'minecraft:map',
        name: 'Empty Map',
    },
    {
        id: 'minecraft:golden_carrot',
        name: 'Golden Carrot',
    },
    {
        id: 'minecraft:skeleton_skull',
        name: 'Skeleton Skull',
    },
    {
        id: 'minecraft:wither_skeleton_skull',
        name: 'Wither Skeleton Skull',
    },
    {
        id: 'minecraft:player_head',
        name: 'Player Head',
    },
    {
        id: 'minecraft:zombie_head',
        name: 'Zombie Head',
    },
    {
        id: 'minecraft:creeper_head',
        name: 'Creeper Head',
    },
    {
        id: 'minecraft:dragon_head',
        name: 'Dragon Head',
    },
    {
        id: 'minecraft:piglin_head',
        name: 'Piglin Head',
    },
    {
        id: 'minecraft:nether_star',
        name: 'Nether Star',
    },
    {
        id: 'minecraft:pumpkin_pie',
        name: 'Pumpkin Pie',
    },
    {
        id: 'minecraft:firework_rocket',
        name: 'Firework Rocket',
    },
    {
        id: 'minecraft:firework_star',
        name: 'Firework Star',
    },
    {
        id: 'minecraft:enchanted_book',
        name: 'Enchanted Book',
    },
    {
        id: 'minecraft:nether_brick',
        name: 'Nether Brick',
    },
    {
        id: 'minecraft:resin_brick',
        name: 'Resin Brick',
    },
    {
        id: 'minecraft:prismarine_shard',
        name: 'Prismarine Shard',
    },
    {
        id: 'minecraft:prismarine_crystals',
        name: 'Prismarine Crystals',
    },
    {
        id: 'minecraft:rabbit',
        name: 'Raw Rabbit',
    },
    {
        id: 'minecraft:cooked_rabbit',
        name: 'Cooked Rabbit',
    },
    {
        id: 'minecraft:rabbit_stew',
        name: 'Rabbit Stew',
    },
    {
        id: 'minecraft:rabbit_foot',
        name: "Rabbit's Foot",
    },
    {
        id: 'minecraft:rabbit_hide',
        name: 'Rabbit Hide',
    },
    {
        id: 'minecraft:armor_stand',
        name: 'Armor Stand',
    },
    {
        id: 'minecraft:copper_horse_armor',
        name: 'Copper Horse Armor',
    },
    {
        id: 'minecraft:iron_horse_armor',
        name: 'Iron Horse Armor',
    },
    {
        id: 'minecraft:golden_horse_armor',
        name: 'Golden Horse Armor',
    },
    {
        id: 'minecraft:diamond_horse_armor',
        name: 'Diamond Horse Armor',
    },
    {
        id: 'minecraft:netherite_horse_armor',
        name: 'Netherite Horse Armor',
    },
    {
        id: 'minecraft:leather_horse_armor',
        name: 'Leather Horse Armor',
    },
    {
        id: 'minecraft:lead',
        name: 'Lead',
    },
    {
        id: 'minecraft:name_tag',
        name: 'Name Tag',
    },
    {
        id: 'minecraft:command_block_minecart',
        name: 'Minecart with Command Block',
    },
    {
        id: 'minecraft:mutton',
        name: 'Raw Mutton',
    },
    {
        id: 'minecraft:cooked_mutton',
        name: 'Cooked Mutton',
    },
    {
        id: 'minecraft:white_banner',
        name: 'White Banner',
    },
    {
        id: 'minecraft:orange_banner',
        name: 'Orange Banner',
    },
    {
        id: 'minecraft:magenta_banner',
        name: 'Magenta Banner',
    },
    {
        id: 'minecraft:light_blue_banner',
        name: 'Light Blue Banner',
    },
    {
        id: 'minecraft:yellow_banner',
        name: 'Yellow Banner',
    },
    {
        id: 'minecraft:lime_banner',
        name: 'Lime Banner',
    },
    {
        id: 'minecraft:pink_banner',
        name: 'Pink Banner',
    },
    {
        id: 'minecraft:gray_banner',
        name: 'Gray Banner',
    },
    {
        id: 'minecraft:light_gray_banner',
        name: 'Light Gray Banner',
    },
    {
        id: 'minecraft:cyan_banner',
        name: 'Cyan Banner',
    },
    {
        id: 'minecraft:purple_banner',
        name: 'Purple Banner',
    },
    {
        id: 'minecraft:blue_banner',
        name: 'Blue Banner',
    },
    {
        id: 'minecraft:brown_banner',
        name: 'Brown Banner',
    },
    {
        id: 'minecraft:green_banner',
        name: 'Green Banner',
    },
    {
        id: 'minecraft:red_banner',
        name: 'Red Banner',
    },
    {
        id: 'minecraft:black_banner',
        name: 'Black Banner',
    },
    {
        id: 'minecraft:end_crystal',
        name: 'End Crystal',
    },
    {
        id: 'minecraft:chorus_fruit',
        name: 'Chorus Fruit',
    },
    {
        id: 'minecraft:popped_chorus_fruit',
        name: 'Popped Chorus Fruit',
    },
    {
        id: 'minecraft:torchflower_seeds',
        name: 'Torchflower Seeds',
    },
    {
        id: 'minecraft:pitcher_pod',
        name: 'Pitcher Pod',
    },
    {
        id: 'minecraft:beetroot',
        name: 'Beetroot',
    },
    {
        id: 'minecraft:beetroot_seeds',
        name: 'Beetroot Seeds',
    },
    {
        id: 'minecraft:beetroot_soup',
        name: 'Beetroot Soup',
    },
    {
        id: 'minecraft:dragon_breath',
        name: "Dragon's Breath",
    },
    {
        id: 'minecraft:splash_potion',
        name: 'Splash Potion',
    },
    {
        id: 'minecraft:spectral_arrow',
        name: 'Spectral Arrow',
    },
    {
        id: 'minecraft:tipped_arrow',
        name: 'Tipped Arrow',
    },
    {
        id: 'minecraft:lingering_potion',
        name: 'Lingering Potion',
    },
    {
        id: 'minecraft:shield',
        name: 'Shield',
    },
    {
        id: 'minecraft:wooden_spear',
        name: 'Wooden Spear',
    },
    {
        id: 'minecraft:stone_spear',
        name: 'Stone Spear',
    },
    {
        id: 'minecraft:copper_spear',
        name: 'Copper Spear',
    },
    {
        id: 'minecraft:iron_spear',
        name: 'Iron Spear',
    },
    {
        id: 'minecraft:golden_spear',
        name: 'Golden Spear',
    },
    {
        id: 'minecraft:diamond_spear',
        name: 'Diamond Spear',
    },
    {
        id: 'minecraft:netherite_spear',
        name: 'Netherite Spear',
    },
    {
        id: 'minecraft:totem_of_undying',
        name: 'Totem of Undying',
    },
    {
        id: 'minecraft:shulker_shell',
        name: 'Shulker Shell',
    },
    {
        id: 'minecraft:iron_nugget',
        name: 'Iron Nugget',
    },
    {
        id: 'minecraft:copper_nugget',
        name: 'Copper Nugget',
    },
    {
        id: 'minecraft:knowledge_book',
        name: 'Knowledge Book',
    },
    {
        id: 'minecraft:debug_stick',
        name: 'Debug Stick',
    },
    {
        id: 'minecraft:music_disc_13',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_cat',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_blocks',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_chirp',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_creator',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_creator_music_box',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_far',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_lava_chicken',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_mall',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_mellohi',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_stal',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_strad',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_ward',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_11',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_wait',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_otherside',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_relic',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_5',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_pigstep',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_precipice',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:music_disc_tears',
        name: 'Music Disc',
    },
    {
        id: 'minecraft:disc_fragment_5',
        name: 'Disc Fragment',
    },
    {
        id: 'minecraft:trident',
        name: 'Trident',
    },
    {
        id: 'minecraft:nautilus_shell',
        name: 'Nautilus Shell',
    },
    {
        id: 'minecraft:iron_nautilus_armor',
        name: 'Iron Nautilus Armor',
    },
    {
        id: 'minecraft:golden_nautilus_armor',
        name: 'Golden Nautilus Armor',
    },
    {
        id: 'minecraft:diamond_nautilus_armor',
        name: 'Diamond Nautilus Armor',
    },
    {
        id: 'minecraft:netherite_nautilus_armor',
        name: 'Netherite Nautilus Armor',
    },
    {
        id: 'minecraft:copper_nautilus_armor',
        name: 'Copper Nautilus Armor',
    },
    {
        id: 'minecraft:heart_of_the_sea',
        name: 'Heart of the Sea',
    },
    {
        id: 'minecraft:crossbow',
        name: 'Crossbow',
    },
    {
        id: 'minecraft:suspicious_stew',
        name: 'Suspicious Stew',
    },
    {
        id: 'minecraft:loom',
        name: 'Loom',
    },
    {
        id: 'minecraft:flower_banner_pattern',
        name: 'Flower Charge Banner Pattern',
    },
    {
        id: 'minecraft:creeper_banner_pattern',
        name: 'Creeper Charge Banner Pattern',
    },
    {
        id: 'minecraft:skull_banner_pattern',
        name: 'Skull Charge Banner Pattern',
    },
    {
        id: 'minecraft:mojang_banner_pattern',
        name: 'Thing Banner Pattern',
    },
    {
        id: 'minecraft:globe_banner_pattern',
        name: 'Globe Banner Pattern',
    },
    {
        id: 'minecraft:piglin_banner_pattern',
        name: 'Snout Banner Pattern',
    },
    {
        id: 'minecraft:flow_banner_pattern',
        name: 'Flow Banner Pattern',
    },
    {
        id: 'minecraft:guster_banner_pattern',
        name: 'Guster Banner Pattern',
    },
    {
        id: 'minecraft:field_masoned_banner_pattern',
        name: 'Field Masoned Banner Pattern',
    },
    {
        id: 'minecraft:bordure_indented_banner_pattern',
        name: 'Bordure Indented Banner Pattern',
    },
    {
        id: 'minecraft:goat_horn',
        name: 'Goat Horn',
    },
    {
        id: 'minecraft:composter',
        name: 'Composter',
    },
    {
        id: 'minecraft:barrel',
        name: 'Barrel',
    },
    {
        id: 'minecraft:smoker',
        name: 'Smoker',
    },
    {
        id: 'minecraft:blast_furnace',
        name: 'Blast Furnace',
    },
    {
        id: 'minecraft:cartography_table',
        name: 'Cartography Table',
    },
    {
        id: 'minecraft:fletching_table',
        name: 'Fletching Table',
    },
    {
        id: 'minecraft:grindstone',
        name: 'Grindstone',
    },
    {
        id: 'minecraft:smithing_table',
        name: 'Smithing Table',
    },
    {
        id: 'minecraft:stonecutter',
        name: 'Stonecutter',
    },
    {
        id: 'minecraft:bell',
        name: 'Bell',
    },
    {
        id: 'minecraft:lantern',
        name: 'Lantern',
    },
    {
        id: 'minecraft:soul_lantern',
        name: 'Soul Lantern',
    },
    {
        id: 'minecraft:copper_lantern',
        name: 'Copper Lantern',
    },
    {
        id: 'minecraft:exposed_copper_lantern',
        name: 'Exposed Copper Lantern',
    },
    {
        id: 'minecraft:weathered_copper_lantern',
        name: 'Weathered Copper Lantern',
    },
    {
        id: 'minecraft:oxidized_copper_lantern',
        name: 'Oxidized Copper Lantern',
    },
    {
        id: 'minecraft:waxed_copper_lantern',
        name: 'Waxed Copper Lantern',
    },
    {
        id: 'minecraft:waxed_exposed_copper_lantern',
        name: 'Waxed Exposed Copper Lantern',
    },
    {
        id: 'minecraft:waxed_weathered_copper_lantern',
        name: 'Waxed Weathered Copper Lantern',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_lantern',
        name: 'Waxed Oxidized Copper Lantern',
    },
    {
        id: 'minecraft:sweet_berries',
        name: 'Sweet Berries',
    },
    {
        id: 'minecraft:glow_berries',
        name: 'Glow Berries',
    },
    {
        id: 'minecraft:campfire',
        name: 'Campfire',
    },
    {
        id: 'minecraft:soul_campfire',
        name: 'Soul Campfire',
    },
    {
        id: 'minecraft:shroomlight',
        name: 'Shroomlight',
    },
    {
        id: 'minecraft:honeycomb',
        name: 'Honeycomb',
    },
    {
        id: 'minecraft:bee_nest',
        name: 'Bee Nest',
    },
    {
        id: 'minecraft:beehive',
        name: 'Beehive',
    },
    {
        id: 'minecraft:honey_bottle',
        name: 'Honey Bottle',
    },
    {
        id: 'minecraft:honeycomb_block',
        name: 'Honeycomb Block',
    },
    {
        id: 'minecraft:lodestone',
        name: 'Lodestone',
    },
    {
        id: 'minecraft:crying_obsidian',
        name: 'Crying Obsidian',
    },
    {
        id: 'minecraft:blackstone',
        name: 'Blackstone',
    },
    {
        id: 'minecraft:blackstone_slab',
        name: 'Blackstone Slab',
    },
    {
        id: 'minecraft:blackstone_stairs',
        name: 'Blackstone Stairs',
    },
    {
        id: 'minecraft:gilded_blackstone',
        name: 'Gilded Blackstone',
    },
    {
        id: 'minecraft:polished_blackstone',
        name: 'Polished Blackstone',
    },
    {
        id: 'minecraft:polished_blackstone_slab',
        name: 'Polished Blackstone Slab',
    },
    {
        id: 'minecraft:polished_blackstone_stairs',
        name: 'Polished Blackstone Stairs',
    },
    {
        id: 'minecraft:chiseled_polished_blackstone',
        name: 'Chiseled Polished Blackstone',
    },
    {
        id: 'minecraft:polished_blackstone_bricks',
        name: 'Polished Blackstone Bricks',
    },
    {
        id: 'minecraft:polished_blackstone_brick_slab',
        name: 'Polished Blackstone Brick Slab',
    },
    {
        id: 'minecraft:polished_blackstone_brick_stairs',
        name: 'Polished Blackstone Brick Stairs',
    },
    {
        id: 'minecraft:cracked_polished_blackstone_bricks',
        name: 'Cracked Polished Blackstone Bricks',
    },
    {
        id: 'minecraft:respawn_anchor',
        name: 'Respawn Anchor',
    },
    {
        id: 'minecraft:candle',
        name: 'Candle',
    },
    {
        id: 'minecraft:white_candle',
        name: 'White Candle',
    },
    {
        id: 'minecraft:orange_candle',
        name: 'Orange Candle',
    },
    {
        id: 'minecraft:magenta_candle',
        name: 'Magenta Candle',
    },
    {
        id: 'minecraft:light_blue_candle',
        name: 'Light Blue Candle',
    },
    {
        id: 'minecraft:yellow_candle',
        name: 'Yellow Candle',
    },
    {
        id: 'minecraft:lime_candle',
        name: 'Lime Candle',
    },
    {
        id: 'minecraft:pink_candle',
        name: 'Pink Candle',
    },
    {
        id: 'minecraft:gray_candle',
        name: 'Gray Candle',
    },
    {
        id: 'minecraft:light_gray_candle',
        name: 'Light Gray Candle',
    },
    {
        id: 'minecraft:cyan_candle',
        name: 'Cyan Candle',
    },
    {
        id: 'minecraft:purple_candle',
        name: 'Purple Candle',
    },
    {
        id: 'minecraft:blue_candle',
        name: 'Blue Candle',
    },
    {
        id: 'minecraft:brown_candle',
        name: 'Brown Candle',
    },
    {
        id: 'minecraft:green_candle',
        name: 'Green Candle',
    },
    {
        id: 'minecraft:red_candle',
        name: 'Red Candle',
    },
    {
        id: 'minecraft:black_candle',
        name: 'Black Candle',
    },
    {
        id: 'minecraft:small_amethyst_bud',
        name: 'Small Amethyst Bud',
    },
    {
        id: 'minecraft:medium_amethyst_bud',
        name: 'Medium Amethyst Bud',
    },
    {
        id: 'minecraft:large_amethyst_bud',
        name: 'Large Amethyst Bud',
    },
    {
        id: 'minecraft:amethyst_cluster',
        name: 'Amethyst Cluster',
    },
    {
        id: 'minecraft:pointed_dripstone',
        name: 'Pointed Dripstone',
    },
    {
        id: 'minecraft:ochre_froglight',
        name: 'Ochre Froglight',
    },
    {
        id: 'minecraft:verdant_froglight',
        name: 'Verdant Froglight',
    },
    {
        id: 'minecraft:pearlescent_froglight',
        name: 'Pearlescent Froglight',
    },
    {
        id: 'minecraft:frogspawn',
        name: 'Frogspawn',
    },
    {
        id: 'minecraft:echo_shard',
        name: 'Echo Shard',
    },
    {
        id: 'minecraft:brush',
        name: 'Brush',
    },
    {
        id: 'minecraft:netherite_upgrade_smithing_template',
        name: 'Netherite Upgrade',
    },
    {
        id: 'minecraft:sentry_armor_trim_smithing_template',
        name: 'Sentry Armor Trim',
    },
    {
        id: 'minecraft:dune_armor_trim_smithing_template',
        name: 'Dune Armor Trim',
    },
    {
        id: 'minecraft:coast_armor_trim_smithing_template',
        name: 'Coast Armor Trim',
    },
    {
        id: 'minecraft:wild_armor_trim_smithing_template',
        name: 'Wild Armor Trim',
    },
    {
        id: 'minecraft:ward_armor_trim_smithing_template',
        name: 'Ward Armor Trim',
    },
    {
        id: 'minecraft:eye_armor_trim_smithing_template',
        name: 'Eye Armor Trim',
    },
    {
        id: 'minecraft:vex_armor_trim_smithing_template',
        name: 'Vex Armor Trim',
    },
    {
        id: 'minecraft:tide_armor_trim_smithing_template',
        name: 'Tide Armor Trim',
    },
    {
        id: 'minecraft:snout_armor_trim_smithing_template',
        name: 'Snout Armor Trim',
    },
    {
        id: 'minecraft:rib_armor_trim_smithing_template',
        name: 'Rib Armor Trim',
    },
    {
        id: 'minecraft:spire_armor_trim_smithing_template',
        name: 'Spire Armor Trim',
    },
    {
        id: 'minecraft:wayfinder_armor_trim_smithing_template',
        name: 'Wayfinder Armor Trim',
    },
    {
        id: 'minecraft:shaper_armor_trim_smithing_template',
        name: 'Shaper Armor Trim',
    },
    {
        id: 'minecraft:silence_armor_trim_smithing_template',
        name: 'Silence Armor Trim',
    },
    {
        id: 'minecraft:raiser_armor_trim_smithing_template',
        name: 'Raiser Armor Trim',
    },
    {
        id: 'minecraft:host_armor_trim_smithing_template',
        name: 'Host Armor Trim',
    },
    {
        id: 'minecraft:flow_armor_trim_smithing_template',
        name: 'Flow Armor Trim',
    },
    {
        id: 'minecraft:bolt_armor_trim_smithing_template',
        name: 'Bolt Armor Trim',
    },
    {
        id: 'minecraft:angler_pottery_sherd',
        name: 'Angler Pottery Sherd',
    },
    {
        id: 'minecraft:archer_pottery_sherd',
        name: 'Archer Pottery Sherd',
    },
    {
        id: 'minecraft:arms_up_pottery_sherd',
        name: 'Arms Up Pottery Sherd',
    },
    {
        id: 'minecraft:blade_pottery_sherd',
        name: 'Blade Pottery Sherd',
    },
    {
        id: 'minecraft:brewer_pottery_sherd',
        name: 'Brewer Pottery Sherd',
    },
    {
        id: 'minecraft:burn_pottery_sherd',
        name: 'Burn Pottery Sherd',
    },
    {
        id: 'minecraft:danger_pottery_sherd',
        name: 'Danger Pottery Sherd',
    },
    {
        id: 'minecraft:explorer_pottery_sherd',
        name: 'Explorer Pottery Sherd',
    },
    {
        id: 'minecraft:flow_pottery_sherd',
        name: 'Flow Pottery Sherd',
    },
    {
        id: 'minecraft:friend_pottery_sherd',
        name: 'Friend Pottery Sherd',
    },
    {
        id: 'minecraft:guster_pottery_sherd',
        name: 'Guster Pottery Sherd',
    },
    {
        id: 'minecraft:heart_pottery_sherd',
        name: 'Heart Pottery Sherd',
    },
    {
        id: 'minecraft:heartbreak_pottery_sherd',
        name: 'Heartbreak Pottery Sherd',
    },
    {
        id: 'minecraft:howl_pottery_sherd',
        name: 'Howl Pottery Sherd',
    },
    {
        id: 'minecraft:miner_pottery_sherd',
        name: 'Miner Pottery Sherd',
    },
    {
        id: 'minecraft:mourner_pottery_sherd',
        name: 'Mourner Pottery Sherd',
    },
    {
        id: 'minecraft:plenty_pottery_sherd',
        name: 'Plenty Pottery Sherd',
    },
    {
        id: 'minecraft:prize_pottery_sherd',
        name: 'Prize Pottery Sherd',
    },
    {
        id: 'minecraft:scrape_pottery_sherd',
        name: 'Scrape Pottery Sherd',
    },
    {
        id: 'minecraft:sheaf_pottery_sherd',
        name: 'Sheaf Pottery Sherd',
    },
    {
        id: 'minecraft:shelter_pottery_sherd',
        name: 'Shelter Pottery Sherd',
    },
    {
        id: 'minecraft:skull_pottery_sherd',
        name: 'Skull Pottery Sherd',
    },
    {
        id: 'minecraft:snort_pottery_sherd',
        name: 'Snort Pottery Sherd',
    },
    {
        id: 'minecraft:copper_grate',
        name: 'Copper Grate',
    },
    {
        id: 'minecraft:exposed_copper_grate',
        name: 'Exposed Copper Grate',
    },
    {
        id: 'minecraft:weathered_copper_grate',
        name: 'Weathered Copper Grate',
    },
    {
        id: 'minecraft:oxidized_copper_grate',
        name: 'Oxidized Copper Grate',
    },
    {
        id: 'minecraft:waxed_copper_grate',
        name: 'Waxed Copper Grate',
    },
    {
        id: 'minecraft:waxed_exposed_copper_grate',
        name: 'Waxed Exposed Copper Grate',
    },
    {
        id: 'minecraft:waxed_weathered_copper_grate',
        name: 'Waxed Weathered Copper Grate',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_grate',
        name: 'Waxed Oxidized Copper Grate',
    },
    {
        id: 'minecraft:copper_bulb',
        name: 'Copper Bulb',
    },
    {
        id: 'minecraft:exposed_copper_bulb',
        name: 'Exposed Copper Bulb',
    },
    {
        id: 'minecraft:weathered_copper_bulb',
        name: 'Weathered Copper Bulb',
    },
    {
        id: 'minecraft:oxidized_copper_bulb',
        name: 'Oxidized Copper Bulb',
    },
    {
        id: 'minecraft:waxed_copper_bulb',
        name: 'Waxed Copper Bulb',
    },
    {
        id: 'minecraft:waxed_exposed_copper_bulb',
        name: 'Waxed Exposed Copper Bulb',
    },
    {
        id: 'minecraft:waxed_weathered_copper_bulb',
        name: 'Waxed Weathered Copper Bulb',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_bulb',
        name: 'Waxed Oxidized Copper Bulb',
    },
    {
        id: 'minecraft:copper_chest',
        name: 'Copper Chest',
    },
    {
        id: 'minecraft:exposed_copper_chest',
        name: 'Exposed Copper Chest',
    },
    {
        id: 'minecraft:weathered_copper_chest',
        name: 'Weathered Copper Chest',
    },
    {
        id: 'minecraft:oxidized_copper_chest',
        name: 'Oxidized Copper Chest',
    },
    {
        id: 'minecraft:waxed_copper_chest',
        name: 'Waxed Copper Chest',
    },
    {
        id: 'minecraft:waxed_exposed_copper_chest',
        name: 'Waxed Exposed Copper Chest',
    },
    {
        id: 'minecraft:waxed_weathered_copper_chest',
        name: 'Waxed Weathered Copper Chest',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_chest',
        name: 'Waxed Oxidized Copper Chest',
    },
    {
        id: 'minecraft:copper_golem_statue',
        name: 'Copper Golem Statue',
    },
    {
        id: 'minecraft:exposed_copper_golem_statue',
        name: 'Exposed Copper Golem Statue',
    },
    {
        id: 'minecraft:weathered_copper_golem_statue',
        name: 'Weathered Copper Golem Statue',
    },
    {
        id: 'minecraft:oxidized_copper_golem_statue',
        name: 'Oxidized Copper Golem Statue',
    },
    {
        id: 'minecraft:waxed_copper_golem_statue',
        name: 'Waxed Copper Golem Statue',
    },
    {
        id: 'minecraft:waxed_exposed_copper_golem_statue',
        name: 'Waxed Exposed Copper Golem Statue',
    },
    {
        id: 'minecraft:waxed_weathered_copper_golem_statue',
        name: 'Waxed Weathered Copper Golem Statue',
    },
    {
        id: 'minecraft:waxed_oxidized_copper_golem_statue',
        name: 'Waxed Oxidized Copper Golem Statue',
    },
    {
        id: 'minecraft:trial_spawner',
        name: 'Trial Spawner',
    },
    {
        id: 'minecraft:trial_key',
        name: 'Trial Key',
    },
    {
        id: 'minecraft:ominous_trial_key',
        name: 'Ominous Trial Key',
    },
    {
        id: 'minecraft:vault',
        name: 'Vault',
    },
    {
        id: 'minecraft:ominous_bottle',
        name: 'Ominous Bottle',
    },
];
